
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("IOtUu", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ggg0l = parcelRequire("ggg0l");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $9KSWX = parcelRequire("9KSWX");


var $iODl6 = parcelRequire("iODl6");


var $aIOjp = parcelRequire("aIOjp");


var $iDrrr = parcelRequire("iDrrr");


var $bz59w = parcelRequire("bz59w");


var $1knih = parcelRequire("1knih");


var $36CpU = parcelRequire("36CpU");


var $ifxxS = parcelRequire("ifxxS");


var $EOob6 = parcelRequire("EOob6");


var $8D4k8 = parcelRequire("8D4k8");


var $2IHCL = parcelRequire("2IHCL");


var $lzska = parcelRequire("lzska");


var $9hXom = parcelRequire("9hXom");

const $46ac5ef403d19855$var$textLinkCssVar = '--ds-ctl';
const $46ac5ef403d19855$var$textDefaultCssVar = '--ds-ct';
const $46ac5ef403d19855$var$textActiveCssVar = '--ds-ctp';
const $46ac5ef403d19855$var$backgroundHoverCssVar = '--ds-cbh';
const $46ac5ef403d19855$var$backgroundActiveCssVar = '--ds-cba';
var $46ac5ef403d19855$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($46ac5ef403d19855$var$TagStatus || {});
const $46ac5ef403d19855$var$packageName = "platform-pkg";
const $46ac5ef403d19855$var$packageVersion = "0.0.0-use.local";
const $46ac5ef403d19855$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $46ac5ef403d19855$var$removingStyles = null;
const $46ac5ef403d19855$var$RemovableTagComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(85);
    let appearance;
    let href;
    let linkComponent;
    let maxWidth;
    let migration_fallback;
    let removeButtonLabel;
    let rest;
    let swatchBefore;
    let swatchBeforeLabel;
    let swatchBeforeRole;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let testId;
    if ($[0] !== t0) {
        ({ appearance: appearance, elemBefore: t1, isRemovable: t2, text: t3, color: t4, href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: t5, onAfterRemoveAction: t6, linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: t7, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = href;
        $[3] = linkComponent;
        $[4] = maxWidth;
        $[5] = migration_fallback;
        $[6] = removeButtonLabel;
        $[7] = rest;
        $[8] = swatchBefore;
        $[9] = swatchBeforeLabel;
        $[10] = swatchBeforeRole;
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = testId;
    } else {
        appearance = $[1];
        href = $[2];
        linkComponent = $[3];
        maxWidth = $[4];
        migration_fallback = $[5];
        removeButtonLabel = $[6];
        rest = $[7];
        swatchBefore = $[8];
        swatchBeforeLabel = $[9];
        swatchBeforeRole = $[10];
        t1 = $[11];
        t2 = $[12];
        t3 = $[13];
        t4 = $[14];
        t5 = $[15];
        t6 = $[16];
        t7 = $[17];
        testId = $[18];
    }
    const elemBefore = t1 === undefined ? null : t1;
    const isRemovable = t2 === undefined ? true : t2;
    const text = t3 === undefined ? "" : t3;
    const color = t4 === undefined ? "standard" : t4;
    const onBeforeRemoveAction = t5 === undefined ? $46ac5ef403d19855$var$defaultBeforeRemoveAction : t5;
    const onAfterRemoveAction = t6 === undefined ? (0, $dpsRj.default) : t6;
    const hasMargin = t7 === undefined ? true : t7;
    const [status, setStatus] = (0, $cozmU.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $cozmU.useState)(false);
    let t8;
    if ($[19] !== text) {
        t8 = (0, $1knih.getTagText)(text);
        $[19] = text;
        $[20] = t8;
    } else t8 = $[20];
    const normalizedText = t8;
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            action: "removed",
            actionSubject: "tag",
            attributes: {
                componentName: "tag",
                packageName: $46ac5ef403d19855$var$packageName,
                packageVersion: $46ac5ef403d19855$var$packageVersion
            }
        };
        $[21] = t9;
    } else t9 = $[21];
    const onAfterRemoveActionWithAnalytics = (0, $ggg0l.useCallbackWithAnalytics)(onAfterRemoveAction, t9, "atlaskit");
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            setStatus("removed");
        };
        $[22] = t10;
    } else t10 = $[22];
    const handleRemoveComplete = t10;
    let t11;
    if ($[23] !== normalizedText || $[24] !== onAfterRemoveActionWithAnalytics || $[25] !== onBeforeRemoveAction) {
        t11 = ()=>{
            if (onBeforeRemoveAction && onBeforeRemoveAction()) {
                onAfterRemoveActionWithAnalytics(normalizedText);
                handleRemoveComplete();
            }
        };
        $[23] = normalizedText;
        $[24] = onAfterRemoveActionWithAnalytics;
        $[25] = onBeforeRemoveAction;
        $[26] = t11;
    } else t11 = $[26];
    const handleRemoveRequest = t11;
    let t12;
    if ($[27] !== handleRemoveRequest) {
        t12 = (e)=>{
            const spacebarOrEnter = e.key === " " || e.key === "Enter";
            if (spacebarOrEnter) {
                e.stopPropagation();
                handleRemoveRequest();
            }
        };
        $[27] = handleRemoveRequest;
        $[28] = t12;
    } else t12 = $[28];
    const onKeyPress = t12;
    let t13;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>setStatus("removing");
        $[29] = t13;
    } else t13 = $[29];
    const removingTag = t13;
    let t14;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>setStatus("showing");
        $[30] = t14;
    } else t14 = $[30];
    const showingTag = t14;
    let t15;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>setIsHoverCloseButton(true);
        $[31] = t15;
    } else t15 = $[31];
    const handleMouseOver = t15;
    let t16;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>setIsHoverCloseButton(false);
        $[32] = t16;
    } else t16 = $[32];
    const handleMouseOut = t16;
    let t17;
    if ($[33] !== handleRemoveRequest || $[34] !== isRemovable || $[35] !== normalizedText || $[36] !== onKeyPress || $[37] !== removeButtonLabel || $[38] !== testId) {
        t17 = isRemovable ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9hXom.default), {
            "aria-label": `${removeButtonLabel || "Remove"} ${normalizedText}`,
            onClick: handleRemoveRequest,
            onFocus: removingTag,
            onBlur: showingTag,
            onKeyPress: onKeyPress,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            testId: `close-button-${testId}`
        }) : undefined;
        $[33] = handleRemoveRequest;
        $[34] = isRemovable;
        $[35] = normalizedText;
        $[36] = onKeyPress;
        $[37] = removeButtonLabel;
        $[38] = testId;
        $[39] = t17;
    } else t17 = $[39];
    const removeButton = t17;
    if (migration_fallback === "lozenge" && !(0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        let t18;
        if ($[40] !== color) {
            t18 = (0, $2IHCL.getLozengeAppearance)(color);
            $[40] = color;
            $[41] = t18;
        } else t18 = $[41];
        const lozengeAppearance = t18;
        let t19;
        if ($[42] !== lozengeAppearance || $[43] !== normalizedText || $[44] !== rest || $[45] !== testId) {
            t19 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                appearance: lozengeAppearance,
                isBold: false,
                testId: testId,
                ...rest,
                children: normalizedText
            });
            $[42] = lozengeAppearance;
            $[43] = normalizedText;
            $[44] = rest;
            $[45] = testId;
            $[46] = t19;
        } else t19 = $[46];
        return t19;
    }
    if ((0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        const newColor = (0, $bz59w.colorMapping)[color || "standard"];
        let t18;
        if ($[47] !== elemBefore || $[48] !== hasMargin || $[49] !== href || $[50] !== isRemovable || $[51] !== maxWidth || $[52] !== newColor || $[53] !== normalizedText || $[54] !== onAfterRemoveActionWithAnalytics || $[55] !== onBeforeRemoveAction || $[56] !== ref || $[57] !== removeButtonLabel || $[58] !== swatchBefore || $[59] !== swatchBeforeLabel || $[60] !== swatchBeforeRole || $[61] !== testId) {
            t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $36CpU.default), {
                ref: ref,
                color: newColor,
                text: normalizedText,
                elemBefore: elemBefore,
                href: href,
                testId: testId,
                isRemovable: isRemovable,
                removeButtonLabel: removeButtonLabel,
                onBeforeRemoveAction: onBeforeRemoveAction,
                onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
                maxWidth: maxWidth,
                hasMargin: hasMargin,
                swatchBefore: swatchBefore,
                swatchBeforeLabel: swatchBeforeLabel,
                swatchBeforeRole: swatchBeforeRole
            });
            $[47] = elemBefore;
            $[48] = hasMargin;
            $[49] = href;
            $[50] = isRemovable;
            $[51] = maxWidth;
            $[52] = newColor;
            $[53] = normalizedText;
            $[54] = onAfterRemoveActionWithAnalytics;
            $[55] = onBeforeRemoveAction;
            $[56] = ref;
            $[57] = removeButtonLabel;
            $[58] = swatchBefore;
            $[59] = swatchBeforeLabel;
            $[60] = swatchBeforeRole;
            $[61] = testId;
            $[62] = t18;
        } else t18 = $[62];
        return t18;
    }
    let t18;
    if ($[63] !== color || $[64] !== elemBefore || $[65] !== href || $[66] !== isRemovable || $[67] !== linkComponent || $[68] !== normalizedText || $[69] !== testId) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lzska.default), {
            elemBefore: elemBefore,
            isRemovable: isRemovable,
            text: normalizedText,
            color: color,
            href: href,
            linkComponent: linkComponent,
            testId: testId
        });
        $[63] = color;
        $[64] = elemBefore;
        $[65] = href;
        $[66] = isRemovable;
        $[67] = linkComponent;
        $[68] = normalizedText;
        $[69] = testId;
        $[70] = t18;
    } else t18 = $[70];
    const content = t18;
    let t19;
    if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            [$46ac5ef403d19855$var$backgroundHoverCssVar]: undefined,
            [$46ac5ef403d19855$var$backgroundActiveCssVar]: undefined,
            [$46ac5ef403d19855$var$textDefaultCssVar]: undefined,
            [$46ac5ef403d19855$var$textActiveCssVar]: undefined,
            [$46ac5ef403d19855$var$textLinkCssVar]: undefined
        };
        $[71] = t19;
    } else t19 = $[71];
    const hoverCloseButtonColors = t19;
    let t20;
    if ($[72] !== appearance || $[73] !== color || $[74] !== content || $[75] !== elemBefore || $[76] !== href || $[77] !== isHoverCloseButton || $[78] !== ref || $[79] !== removeButton || $[80] !== status || $[81] !== testId) {
        t20 = !(status === "removed") && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aIOjp.default), {
            onFinish: handleRemoveComplete,
            children: (motion)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $EOob6.default), {
                    ref: (0, $lmzCg.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8D4k8.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hekY6.default)([
                        status === "removing" && "_2jz3qF98eZ _1YptrxYbGa _43ViZ1T6kp _0M1xawwTRR"
                    ])
                })
        }, "atlaskit-removable-tag-legacy-shrink-out");
        $[72] = appearance;
        $[73] = color;
        $[74] = content;
        $[75] = elemBefore;
        $[76] = href;
        $[77] = isHoverCloseButton;
        $[78] = ref;
        $[79] = removeButton;
        $[80] = status;
        $[81] = testId;
        $[82] = t20;
    } else t20 = $[82];
    let t21;
    if ($[83] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            children: t20
        });
        $[83] = t20;
        $[84] = t21;
    } else t21 = $[84];
    return t21;
} : ({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $46ac5ef403d19855$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $dpsRj.default), linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, ...rest }, ref)=>{
    const [status, setStatus] = (0, $cozmU.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $cozmU.useState)(false);
    const normalizedText = (0, $1knih.getTagText)(text);
    const onAfterRemoveActionWithAnalytics = (0, $ggg0l.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $46ac5ef403d19855$var$packageName,
            packageVersion: $46ac5ef403d19855$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $cozmU.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, $cozmU.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    const onKeyPress = (0, $cozmU.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $cozmU.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $cozmU.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $cozmU.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $cozmU.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9hXom.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${normalizedText}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined; // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $2IHCL.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: normalizedText
        });
    } // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $bz59w.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $36CpU.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    } // Original implementation
    const content = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lzska.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$46ac5ef403d19855$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$46ac5ef403d19855$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$46ac5ef403d19855$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$46ac5ef403d19855$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$46ac5ef403d19855$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aIOjp.default), {
            onFinish: handleRemoveComplete,
            children: (motion)=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $EOob6.default), {
                    ref: (0, $lmzCg.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8D4k8.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hekY6.default)([
                        status === "removing" && "_2jz3qF98eZ _1YptrxYbGa _43ViZ1T6kp _0M1xawwTRR"
                    ])
                });
            }
        }, "atlaskit-removable-tag-legacy-shrink-out")
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $46ac5ef403d19855$var$RemovableTag = (0, $ifxxS.markAsTagMotionCapable)(/*#__PURE__*/ (0, $cozmU.memo)($46ac5ef403d19855$var$RemovableTagComponent));
var $46ac5ef403d19855$export$2e2bcd8739ae039 = $46ac5ef403d19855$var$RemovableTag;
module.exports["default"] = $46ac5ef403d19855$export$2e2bcd8739ae039;

});

parcelRegister("9KSWX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $aCJyI = parcelRequire("aCJyI");

const $fe2d9ff5b1cbfded$var$styles = {
    container: "_0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _24h04i2Njc _1mT5xd5HSx _3L9DPXBY1A _0LQT5E1Y8M _03SyCP1Y8M",
    containerSubtle: "_3e6OgrA17z",
    text: "_4bt5LAnQyn _2WAcuGnQyn _0WKd3G4z3T _4ya3eEdLIE _2l4i3rzUZr _1kk5Tkmb2E _26BoRwey7F _39HuIbz8Lp _41LZZBAv7U _1ANEUSLRg7",
    customLetterspacing: "_3iugoSrrwU",
    'bg.bold.default': "_0KLXru1qiM",
    'bg.bold.inprogress': "_0KLXru1tR5",
    'bg.bold.moved': "_0KLXruBh49",
    'bg.bold.new': "_0KLXruyx6K",
    'bg.bold.removed': "_0KLXruicO2",
    'bg.bold.success': "_0KLXruK1e6",
    'bg.subtle.default': "_0KLXru66of",
    'bg.subtle.inprogress': "_0KLXru66of",
    'bg.subtle.moved': "_0KLXru66of",
    'bg.subtle.new': "_0KLXru66of",
    'bg.subtle.removed': "_0KLXru66of",
    'bg.subtle.success': "_0KLXru66of",
    'outline.subtle.default': "_2xIroYT3oA _497WNw6wH8 _2zndICHZdu",
    'outline.subtle.inprogress': "_2xIroYTOnn _497WNw6wH8 _2zndICHZdu",
    'outline.subtle.moved': "_2xIroYmPNR _497WNw6wH8 _2zndICHZdu",
    'outline.subtle.new': "_2xIroYEWfT _497WNw6wH8 _2zndICHZdu",
    'outline.subtle.removed': "_2xIroYbxQq _497WNw6wH8 _2zndICHZdu",
    'outline.subtle.success': "_2xIroYc0Gz _497WNw6wH8 _2zndICHZdu",
    'text.subtle': "_1UtDYzy7kJ",
    'text.bold': "_1UtDYzDTSe"
};
const $fe2d9ff5b1cbfded$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $fe2d9ff5b1cbfded$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $fe2d9ff5b1cbfded$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
const $fe2d9ff5b1cbfded$var$LegacyLozenge = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, testId: testId, isBold: t1, appearance: t2, maxWidth: t3, style: style } = t0;
    const isBold = t1 === undefined ? false : t1;
    const appearance = t2 === undefined ? "default" : t2;
    const maxWidth = t3 === undefined ? 200 : t3;
    const appearanceStyle = isBold ? "bold" : "subtle";
    const appearanceType = $fe2d9ff5b1cbfded$var$appearanceTypes.includes(appearance) || $fe2d9ff5b1cbfded$var$newSemanticColors.includes(appearance) ? $fe2d9ff5b1cbfded$var$appearanceMapping[appearance] : "default";
    const maxWidthValue = typeof maxWidth === "string" ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    const t4 = style?.backgroundColor;
    const t5 = maxWidthIsPc ? maxWidth : "100%";
    let t6;
    if ($[0] !== t4 || $[1] !== t5) {
        t6 = {
            backgroundColor: t4,
            maxWidth: t5
        };
        $[0] = t4;
        $[1] = t5;
        $[2] = t6;
    } else t6 = $[2];
    const t7 = $fe2d9ff5b1cbfded$var$styles[`bg.${appearanceStyle}.${appearanceType}`];
    const t8 = appearanceStyle === "subtle" && $fe2d9ff5b1cbfded$var$styles[`outline.subtle.${appearanceType}`];
    const t9 = appearanceStyle === "subtle" && $fe2d9ff5b1cbfded$var$styles.containerSubtle;
    let t10;
    if ($[3] !== t7 || $[4] !== t8 || $[5] !== t9) {
        t10 = (0, $hekY6.default)([
            $fe2d9ff5b1cbfded$var$styles.container,
            t7,
            t8,
            t9
        ]);
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
        $[6] = t10;
    } else t10 = $[6];
    const t11 = style?.color;
    const t12 = maxWidthIsPc ? "100%" : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`;
    let t13;
    if ($[7] !== t11 || $[8] !== t12) {
        t13 = {
            color: t11,
            maxWidth: t12
        };
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const t14 = testId && `${testId}--text`;
    let t15;
    if ($[10] !== appearanceStyle) {
        t15 = (0, $hekY6.default)([
            $fe2d9ff5b1cbfded$var$styles.text,
            (0, $iDrrr.fg)("platform-lozenge-custom-letterspacing") && $fe2d9ff5b1cbfded$var$styles.customLetterspacing,
            $fe2d9ff5b1cbfded$var$styles[`text.${appearanceStyle}`]
        ]);
        $[10] = appearanceStyle;
        $[11] = t15;
    } else t15 = $[11];
    let t16;
    if ($[12] !== children || $[13] !== t13 || $[14] !== t14 || $[15] !== t15) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: t13,
            "data-testid": t14,
            className: t15,
            children: children
        });
        $[12] = children;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
        $[16] = t16;
    } else t16 = $[16];
    let t17;
    if ($[17] !== t10 || $[18] !== t16 || $[19] !== t6 || $[20] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: t6,
            "data-testid": testId,
            className: t10,
            children: t16
        });
        $[17] = t10;
        $[18] = t16;
        $[19] = t6;
        $[20] = testId;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $cozmU.useMemo)(()=>$fe2d9ff5b1cbfded$var$appearanceTypes.includes(appearance) || $fe2d9ff5b1cbfded$var$newSemanticColors.includes(appearance) ? $fe2d9ff5b1cbfded$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $fe2d9ff5b1cbfded$var$styles.container,
            $fe2d9ff5b1cbfded$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $fe2d9ff5b1cbfded$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $fe2d9ff5b1cbfded$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $hekY6.default)([
                $fe2d9ff5b1cbfded$var$styles.text,
                (0, $iDrrr.fg)('platform-lozenge-custom-letterspacing') && $fe2d9ff5b1cbfded$var$styles.customLetterspacing,
                $fe2d9ff5b1cbfded$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$fe2d9ff5b1cbfded$var$LegacyLozenge.displayName = 'Lozenge'; /**
                                        * Wrapper component that switches between old and new Lozenge based on feature flag
                                        */ 
const $fe2d9ff5b1cbfded$var$LozengeWrapper = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if ((0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aCJyI.default), {
                ...props
            });
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    const t0 = props;
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($fe2d9ff5b1cbfded$var$LegacyLozenge, {
            ...t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aCJyI.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fe2d9ff5b1cbfded$var$LegacyLozenge, {
        ...props
    });
});
$fe2d9ff5b1cbfded$var$LozengeWrapper.displayName = 'Lozenge';
var $fe2d9ff5b1cbfded$export$2e2bcd8739ae039 = $fe2d9ff5b1cbfded$var$LozengeWrapper;
module.exports["default"] = $fe2d9ff5b1cbfded$export$2e2bcd8739ae039;

});

parcelRegister("aCJyI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jALA9 = parcelRequire("jALA9");

const $a206409c1b513c29$var$Lozenge = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: t1, spacing: t2, maxWidth: t3, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance } = t0;
    const appearance = t1 === undefined ? "neutral" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const maxWidth = t3 === undefined ? 200 : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== children || $[2] !== iconBefore || $[3] !== maxWidth || $[4] !== spacing || $[5] !== style || $[6] !== testId || $[7] !== trailingMetric || $[8] !== trailingMetricAppearance) {
        t4 = {
            appearance: appearance,
            spacing: spacing,
            iconBefore: iconBefore,
            trailingMetric: trailingMetric,
            trailingMetricAppearance: trailingMetricAppearance,
            maxWidth: maxWidth,
            style: style,
            testId: testId,
            children: children
        };
        $[0] = appearance;
        $[1] = children;
        $[2] = iconBefore;
        $[3] = maxWidth;
        $[4] = spacing;
        $[5] = style;
        $[6] = testId;
        $[7] = trailingMetric;
        $[8] = trailingMetricAppearance;
        $[9] = t4;
    } else t4 = $[9];
    const baseProps = t4;
    let t5;
    if ($[10] !== baseProps || $[11] !== children) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jALA9.default), {
            ...baseProps,
            children: children
        });
        $[10] = baseProps;
        $[11] = children;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jALA9.default), {
        ...baseProps,
        children: children
    });
};
$a206409c1b513c29$var$Lozenge.displayName = 'Lozenge';
var $a206409c1b513c29$export$2e2bcd8739ae039 = $a206409c1b513c29$var$Lozenge;
module.exports["default"] = $a206409c1b513c29$export$2e2bcd8739ae039;

});

parcelRegister("78t8C", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4aRua = parcelRequire("4aRua");


var $IQ4Dz = parcelRequire("IQ4Dz");

function $40256e28ed729ab7$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $40256e28ed729ab7$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $40256e28ed729ab7$var$getSafeValue(value);
    const safeMax = $40256e28ed729ab7$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


// Nested selectors with data attributes are required for theme switching
const $64d03919025ec445$var$stylesNew = {
    root: "_0bjKvDcjp5 _2Y7lL41Y8M _4c065UdnbC _3iDTPbccYA _24h04i2Njc _4ouGXINHnM _37wbyuDIqT _3YEZNOdnbC _3L9DPXBY1A",
    success: "_1UtDYzM9Wa _0KLXruQuCm",
    danger: "_1UtDYzOZ2O _0KLXruJXmd",
    warning: "_1UtDYzVRW9 _0KLXru2bwY",
    information: "_1UtDYzdx2f _0KLXru9V7L",
    discovery: "_1UtDYzAGgF _0KLXruZB9y",
    neutral: "_1UtDYzy7kJ _0KLXruG6qS",
    inverse: "_0KLXrulfZc _1UtDYzy7kJ",
    informationBold: "_1UtDYzdx2f _0KLXruJVoT",
    successBold: "_1UtDYzM9Wa _0KLXruX1bq",
    dangerBold: "_1UtDYzOZ2O _0KLXrug6EK",
    warningBold: "_1UtDYzVRW9 _0KLXruKLKE",
    warningBoldDark: "_1UtDYzVRW9 _0KLXruDh4Z",
    discoveryBold: "_1UtDYzAGgF _0KLXruXfaS"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $64d03919025ec445$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $40256e28ed729ab7$export$7c4d25c0c3217d8c)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const $64d03919025ec445$var$BadgeNew = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function BadgeNew(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { appearance: t1, children: t2, max: t3, style: style, testId: testId } = t0;
    const appearance = t1 === undefined ? "neutral" : t1;
    const children = t2 === undefined ? 0 : t2;
    const max = t3 === undefined ? 99 : t3;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const resolvedAppearance = appearance === "warningBold" && colorMode === "dark" ? "warningBoldDark" : appearance;
    const t4 = style?.backgroundColor;
    const t5 = style?.color;
    let t6;
    if ($[0] !== t4 || $[1] !== t5) {
        t6 = {
            background: t4,
            color: t5
        };
        $[0] = t4;
        $[1] = t5;
        $[2] = t6;
    } else t6 = $[2];
    const t7 = $64d03919025ec445$var$stylesNew[resolvedAppearance];
    let t8;
    if ($[3] !== t7) {
        t8 = (0, $hekY6.default)([
            $64d03919025ec445$var$stylesNew.root,
            t7
        ]);
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    let t9;
    if ($[5] !== children || $[6] !== max) {
        t9 = $64d03919025ec445$var$badgeValueWithNegativeNumberSupported(children, max);
        $[5] = children;
        $[6] = max;
        $[7] = t9;
    } else t9 = $[7];
    let t10;
    if ($[8] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: t9
        });
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10 || $[11] !== t6 || $[12] !== t8 || $[13] !== testId) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t6,
            className: t8,
            children: t10
        });
        $[10] = t10;
        $[11] = t6;
        $[12] = t8;
        $[13] = testId;
        $[14] = t11;
    } else t11 = $[14];
    return t11;
} : function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $hekY6.default)([
            $64d03919025ec445$var$stylesNew.root,
            $64d03919025ec445$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $64d03919025ec445$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $64d03919025ec445$export$2e2bcd8739ae039 = $64d03919025ec445$var$BadgeNew;
module.exports["default"] = $64d03919025ec445$export$2e2bcd8739ae039;

});

parcelRegister("4yg9g", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f0e43653e0117dc8$var$containerMedia = {
    invalid: "_1vgHBHBvTi",
    disabled: "_0s2BCh5l5r"
};
const $f0e43653e0117dc8$var$inputMediaDisabled = null;
const $f0e43653e0117dc8$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f0e43653e0117dc8$var$disabledStyle = {
    standard: "_3vBAKHVrZW _0KLXruVrZW _1UtDYzot27 _0wOv4Qsyl5",
    subtle: "_3vBAKHjOvk _0KLXrujOvk _1UtDYzot27 _0wOv4Qsyl5",
    none: "_3vBAKHjOvk _0KLXrujOvk _1UtDYzot27 _0wOv4Qsyl5"
};
const $f0e43653e0117dc8$var$invalidStyle = null;
const $f0e43653e0117dc8$var$focusWithinStyle = {
    standard: "_42KcrLnXvL _1JBGj5utHW _1IRfN3PhRM",
    subtle: "_42KcrLnXvL _1JBGj5utHW _1IRfN3PhRM",
    none: "_42KcrLjOvk _1JBGj5jOvk _1IRfN3w5zn"
};
const $f0e43653e0117dc8$var$hoverStyle = {
    standard: "_0hPERGHKt7 _1eOmH6qWX3",
    subtle: "_0hPERGHKt7 _1eOmH6qWX3",
    none: "_0hPERGjOvk _1eOmH6jOvk"
};
const $f0e43653e0117dc8$var$getContainerTextBgAndBorderColor = {
    standard: "_3vBAKHHKt7 _3hxITi6wH8 _1UtDYzy7kJ _0wOv4QJxkL _0KLXru7Cj1 _1vgHBHBvTi",
    subtle: "_3vBAKHjOvk _3hxITi6wH8 _1UtDYzy7kJ _0wOv4QJxkL _2NQRvXjOvk _1vgHBHBvTi",
    none: "_3vBAKHjOvk _3hxITiYbGa _1UtDYzy7kJ _0wOv4QJxkL _2NQRvXjOvk _1vgHBHBvTi"
};
const $f0e43653e0117dc8$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $f0e43653e0117dc8$var$getMaxWidth = (width)=>!width ? `100%` : width in $f0e43653e0117dc8$var$widthMap ? `${$f0e43653e0117dc8$var$widthMap[width]}px` : `${+width}px`;
const $f0e43653e0117dc8$var$containerStyleAppearance = {
    standard: "_3hxITi6wH8 _46hvQmNvrM _0xmtkoNvrM _0LQT5EdnbC _03SyCPdnbC",
    subtle: "_3hxITi6wH8 _46hvQmNvrM _0xmtkoNvrM _0LQT5EdnbC _03SyCPdnbC",
    none: "_3hxITiYbGa"
};
const $f0e43653e0117dc8$var$containerStyles = null;
const $f0e43653e0117dc8$var$inputDisabledStyle = null;
const $f0e43653e0117dc8$var$inputCompactStyle = null;
const $f0e43653e0117dc8$var$inputMonospacedStyle = null; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f0e43653e0117dc8$var$inputStyle = null;
const $f0e43653e0117dc8$var$finessePlaceholderStyle = null; /**
                                       * __Textfield__
                                       *
                                       * A text field is an input that allows a user to write or edit text.
                                       *
                                       * - [Examples](https://atlassian.design/components/textfield/examples)
                                       * - [Code](https://atlassian.design/components/textfield/code)
                                       * - [Usage](https://atlassian.design/components/textfield/usage)
                                       */ 
const $f0e43653e0117dc8$var$Textfield = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(73);
    let className;
    let elemAfterInput;
    let elemBeforeInput;
    let name;
    let onBlur;
    let onChange;
    let onFocus;
    let onMouseDown;
    let placeholder;
    let spreadProps;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let testId;
    let width;
    if ($[0] !== props) {
        ({ appearance: t0, className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: t1, isDisabled: t2, isInvalid: t3, isMonospaced: t4, isReadOnly: t5, isRequired: t6, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props);
        $[0] = props;
        $[1] = className;
        $[2] = elemAfterInput;
        $[3] = elemBeforeInput;
        $[4] = name;
        $[5] = onBlur;
        $[6] = onChange;
        $[7] = onFocus;
        $[8] = onMouseDown;
        $[9] = placeholder;
        $[10] = spreadProps;
        $[11] = t0;
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = testId;
        $[19] = width;
    } else {
        className = $[1];
        elemAfterInput = $[2];
        elemBeforeInput = $[3];
        name = $[4];
        onBlur = $[5];
        onChange = $[6];
        onFocus = $[7];
        onMouseDown = $[8];
        placeholder = $[9];
        spreadProps = $[10];
        t0 = $[11];
        t1 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        testId = $[18];
        width = $[19];
    }
    const appearance = t0 === undefined ? "standard" : t0;
    const isCompact = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isInvalid = t3 === undefined ? false : t3;
    const isMonospaced = t4 === undefined ? false : t4;
    const isReadOnly = t5 === undefined ? false : t5;
    const isRequired = t6 === undefined ? false : t6;
    const inputRef = (0, $cozmU.useRef)(null);
    let t7;
    if ($[20] !== onFocus) {
        t7 = {
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: "focused",
            ...$f0e43653e0117dc8$var$analyticsParams
        };
        $[20] = onFocus;
        $[21] = t7;
    } else t7 = $[21];
    const handleOnFocus = (0, $7r5Hr.usePlatformLeafEventHandler)(t7);
    let t8;
    if ($[22] !== onBlur) {
        t8 = {
            fn: (event_0)=>{
                onBlur && onBlur(event_0);
            },
            action: "blurred",
            ...$f0e43653e0117dc8$var$analyticsParams
        };
        $[22] = onBlur;
        $[23] = t8;
    } else t8 = $[23];
    const handleOnBlur = (0, $7r5Hr.usePlatformLeafEventHandler)(t8);
    let t9;
    if ($[24] !== isDisabled || $[25] !== onMouseDown) {
        t9 = (event_1)=>{
            const target = event_1.target;
            if (target.tagName !== "INPUT") event_1.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event_1);
        };
        $[24] = isDisabled;
        $[25] = onMouseDown;
        $[26] = t9;
    } else t9 = $[26];
    const handleOnMouseDown = t9;
    let t10;
    if ($[27] !== ref) {
        t10 = (inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === "object") ref.current = inputElement;
            if (typeof ref === "function") ref(inputElement);
        };
        $[27] = ref;
        $[28] = t10;
    } else t10 = $[28];
    const setInputRef = t10;
    const t11 = isDisabled ? isDisabled : undefined;
    const t12 = isInvalid ? isInvalid : undefined;
    const t13 = testId && `${testId}-container`;
    let t14;
    if ($[29] !== width) {
        t14 = $f0e43653e0117dc8$var$getMaxWidth(width);
        $[29] = width;
        $[30] = t14;
    } else t14 = $[30];
    const t15 = `${t14}`;
    let t16;
    if ($[31] !== t15) {
        t16 = {
            maxWidth: t15
        };
        $[31] = t15;
        $[32] = t16;
    } else t16 = $[32];
    const t17 = $f0e43653e0117dc8$var$getContainerTextBgAndBorderColor[appearance];
    const t18 = $f0e43653e0117dc8$var$containerStyleAppearance[appearance];
    const t19 = !isDisabled && $f0e43653e0117dc8$var$focusWithinStyle[appearance];
    const t20 = !isDisabled && $f0e43653e0117dc8$var$hoverStyle[appearance];
    const t21 = isDisabled && $f0e43653e0117dc8$var$containerMedia.disabled;
    const t22 = isDisabled && $f0e43653e0117dc8$var$disabledStyle[appearance];
    const t23 = isInvalid && $f0e43653e0117dc8$var$containerMedia.invalid;
    const t24 = isInvalid && "_3vBAKHnod9 _0hPERGnod9 _2OUyjtFKgL _3fSdSTFKgL _212B7EutHW";
    let t25;
    if ($[33] !== className || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t20 || $[38] !== t21 || $[39] !== t22 || $[40] !== t23 || $[41] !== t24) {
        t25 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _23rrnH5Vpu _2V7sgONvrM _3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _37wbyuI7V3 _1pp6NdIZbP _1RrJLiBwqQ _1T2N03wPeg _4kGtcjKTcp",
            t17,
            t18,
            t19,
            t20,
            t21,
            t22,
            t23,
            t24,
            className
        ]);
        $[33] = className;
        $[34] = t17;
        $[35] = t18;
        $[36] = t19;
        $[37] = t20;
        $[38] = t21;
        $[39] = t22;
        $[40] = t23;
        $[41] = t24;
        $[42] = t25;
    } else t25 = $[42];
    const t26 = isInvalid ? isInvalid : undefined;
    const t27 = isCompact ? isCompact : undefined;
    const t28 = isMonospaced ? isMonospaced : undefined;
    let t29;
    if ($[43] !== isCompact || $[44] !== isDisabled || $[45] !== isMonospaced) {
        t29 = (0, $hekY6.default)([
            "_30huDKdnbC _2sNsIg20Hp _2xIroY98eZ _497WNwYbGa _2zndICT6kp _24h04i2Njc _39xV02N91d _4ouGXIdnbC _0KLXrujOvk _1UtDYzOLYo _0wOv4QOLYo _2FTXAcgVvo _1CDq3qgVvo _3JVwBfgVvo _0tVs2sgVvo _3tCyJvYbGa _2DoaPjYbGa _3Uh30Oz8Lp _3AxjleKGUX _4kBIzkmnOE _1p28eS2ADO _0kWGEq2ADO _3vyjixgVvo _2vXEgagVvo",
            (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
            isMonospaced && "_0WKd3Gfx9v _2GdZyqfx9v",
            isCompact && "_2vsVfZFQfX _3LfWyLFQfX _0SosFGgVvo _2DQpWtgVvo _4h0kCw1Y8M _1ChKrK1Y8M _3iWPk5gVvo _4lPUkfgVvo",
            isDisabled && "_1UtDYzot27 _3Axjleot27",
            isDisabled && "_3ppTuW5l5r"
        ]);
        $[43] = isCompact;
        $[44] = isDisabled;
        $[45] = isMonospaced;
        $[46] = t29;
    } else t29 = $[46];
    let t30;
    if ($[47] !== handleOnBlur || $[48] !== handleOnFocus || $[49] !== isDisabled || $[50] !== isReadOnly || $[51] !== isRequired || $[52] !== name || $[53] !== onChange || $[54] !== placeholder || $[55] !== setInputRef || $[56] !== spreadProps || $[57] !== t26 || $[58] !== t27 || $[59] !== t28 || $[60] !== t29 || $[61] !== testId) {
        t30 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            ...spreadProps,
            "aria-invalid": t26,
            "data-compact": t27,
            "data-ds--text-field--input": true,
            "data-monospaced": t28,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired,
            className: t29
        });
        $[47] = handleOnBlur;
        $[48] = handleOnFocus;
        $[49] = isDisabled;
        $[50] = isReadOnly;
        $[51] = isRequired;
        $[52] = name;
        $[53] = onChange;
        $[54] = placeholder;
        $[55] = setInputRef;
        $[56] = spreadProps;
        $[57] = t26;
        $[58] = t27;
        $[59] = t28;
        $[60] = t29;
        $[61] = testId;
        $[62] = t30;
    } else t30 = $[62];
    let t31;
    if ($[63] !== elemAfterInput || $[64] !== elemBeforeInput || $[65] !== handleOnMouseDown || $[66] !== t11 || $[67] !== t12 || $[68] !== t13 || $[69] !== t16 || $[70] !== t25 || $[71] !== t30) {
        t31 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            role: "presentation",
            "data-disabled": t11,
            "data-invalid": t12,
            "data-ds--text-field--container": true,
            "data-testid": t13,
            onMouseDown: handleOnMouseDown,
            style: t16,
            className: t25,
            children: [
                elemBeforeInput,
                t30,
                elemAfterInput
            ]
        });
        $[63] = elemAfterInput;
        $[64] = elemBeforeInput;
        $[65] = handleOnMouseDown;
        $[66] = t11;
        $[67] = t12;
        $[68] = t13;
        $[69] = t16;
        $[70] = t25;
        $[71] = t30;
        $[72] = t31;
    } else t31 = $[72];
    return t31;
} : (props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $cozmU.useRef)(null);
    const handleOnFocus = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$f0e43653e0117dc8$var$analyticsParams
    });
    const handleOnBlur = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onBlur && onBlur(event_0);
        },
        action: 'blurred',
        ...$f0e43653e0117dc8$var$analyticsParams
    });
    const handleOnMouseDown = (0, $cozmU.useCallback)((event_1)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event_1.target;
        if (target.tagName !== 'INPUT') event_1.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event_1);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $cozmU.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$f0e43653e0117dc8$var$getMaxWidth(width)}`
        },
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _23rrnH5Vpu _2V7sgONvrM _3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _37wbyuI7V3 _1pp6NdIZbP _1RrJLiBwqQ _1T2N03wPeg _4kGtcjKTcp",
            $f0e43653e0117dc8$var$getContainerTextBgAndBorderColor[appearance],
            $f0e43653e0117dc8$var$containerStyleAppearance[appearance],
            !isDisabled && $f0e43653e0117dc8$var$focusWithinStyle[appearance],
            !isDisabled && $f0e43653e0117dc8$var$hoverStyle[appearance],
            isDisabled && $f0e43653e0117dc8$var$containerMedia.disabled,
            isDisabled && $f0e43653e0117dc8$var$disabledStyle[appearance],
            isInvalid && $f0e43653e0117dc8$var$containerMedia.invalid,
            isInvalid && "_3vBAKHnod9 _0hPERGnod9 _2OUyjtFKgL _3fSdSTFKgL _212B7EutHW",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $hekY6.default)([
                    "_30huDKdnbC _2sNsIg20Hp _2xIroY98eZ _497WNwYbGa _2zndICT6kp _24h04i2Njc _39xV02N91d _4ouGXIdnbC _0KLXrujOvk _1UtDYzOLYo _0wOv4QOLYo _2FTXAcgVvo _1CDq3qgVvo _3JVwBfgVvo _0tVs2sgVvo _3tCyJvYbGa _2DoaPjYbGa _3Uh30Oz8Lp _3AxjleKGUX _4kBIzkmnOE _1p28eS2ADO _0kWGEq2ADO _3vyjixgVvo _2vXEgagVvo",
                    (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
                    isMonospaced && "_0WKd3Gfx9v _2GdZyqfx9v",
                    isCompact && "_2vsVfZFQfX _3LfWyLFQfX _0SosFGgVvo _2DQpWtgVvo _4h0kCw1Y8M _1ChKrK1Y8M _3iWPk5gVvo _4lPUkfgVvo",
                    isDisabled && "_1UtDYzot27 _3Axjleot27",
                    isDisabled && "_3ppTuW5l5r"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $f0e43653e0117dc8$export$2e2bcd8739ae039 = $f0e43653e0117dc8$var$Textfield;
module.exports["default"] = $f0e43653e0117dc8$export$2e2bcd8739ae039;

});

parcelRegister("1VhsF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");










parcelRequire("cozmU");


var $iDtkd = parcelRequire("iDtkd");


var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $e9d63e901bf3c453$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDtkd))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $e9d63e901bf3c453$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $e9d63e901bf3c453$var$appearanceIconSchema[appearance] || $e9d63e901bf3c453$var$appearanceIconSchema.information;
    const AppearanceIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
        const $ = (0, $bDgLe.c)(2);
        const { primaryColor: primaryColor } = t0;
        let t1;
        if ($[0] !== primaryColor) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)(appearanceIconStyles.Icon, {
                color: primaryColor,
                spacing: "spacious",
                label: appearance
            });
            $[0] = primaryColor;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    } : ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, $8aG6j.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}


const $b9a8b34800c85bdc$var$sectionMessageStyles = {
    container: "_0bjKvD8fU6 _4c065U5zaO _2Y7lL45zaO _3W2Oc8wPeg",
    iconContainer: "_3SamIHLl21 _3iDTPbQ4SZ",
    contentContainer: "_2O5Vij7dHp",
    content: "_2sNsIgmnOE _1UtDYzy7kJ",
    actionsContainer: "_2sNsIgmnOE",
    dismissButtonContainer: "_43nrzTLl21"
};
const $b9a8b34800c85bdc$var$appearanceStyles = {
    information: "_0KLXrugNg3",
    warning: "_0KLXruhxIM",
    error: "_0KLXruhH7k",
    success: "_0KLXruzaZe",
    discovery: "_0KLXru94rk"
}; /**
    * __Section message__
    *
    * A section message is used to alert users to a particular section of the screen.
    *
    * - [Examples](https://atlassian.design/components/section-message/examples)
    * - [Code](https://atlassian.design/components/section-message/code)
    * - [Usage](https://atlassian.design/components/section-message/usage)
    */ 
const $b9a8b34800c85bdc$var$SectionMessage = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, appearance: t1, actions: actions, title: title, headingLevel: t2, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId } = t0;
    const appearance = t1 === undefined ? "information" : t1;
    const headingLevel = t2 === undefined ? "h2" : t2;
    const [dismissed, setDismissed] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] !== onDismiss) {
        t3 = ()=>{
            onDismiss?.();
            setDismissed(true);
        };
        $[0] = onDismiss;
        $[1] = t3;
    } else t3 = $[1];
    const handleDismiss = t3;
    let t4;
    if ($[2] !== appearance || $[3] !== icon) {
        t4 = (0, $e9d63e901bf3c453$export$e9b82d2e21ac0c1f)(appearance, icon);
        $[2] = appearance;
        $[3] = icon;
        $[4] = t4;
    } else t4 = $[4];
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = t4;
    const actionElements = actions && actions.type === (0, $cozmU.Fragment) ? actions.props.children : actions;
    let t5;
    if ($[5] !== Icon || $[6] !== actionElements || $[7] !== appearance || $[8] !== children || $[9] !== dismissed || $[10] !== handleDismiss || $[11] !== headingLevel || $[12] !== isDismissible || $[13] !== primaryColor || $[14] !== ref || $[15] !== secondaryColor || $[16] !== testId || $[17] !== title) {
        const actionsArray = (0, $cozmU.Children).toArray(actionElements);
        t5 = isDismissible && dismissed ? null : /*#__PURE__*/ (0, $8aG6j.jsx)("section", {
            "data-testid": testId,
            ref: ref,
            className: (0, $hekY6.default)([
                $b9a8b34800c85bdc$var$sectionMessageStyles.container,
                $b9a8b34800c85bdc$var$appearanceStyles[appearance]
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.200",
                alignBlock: "stretch",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            $b9a8b34800c85bdc$var$sectionMessageStyles.iconContainer
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                            size: "medium",
                            primaryColor: primaryColor,
                            secondaryColor: secondaryColor,
                            color: primaryColor,
                            spacing: "spacious"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.100",
                        testId: testId && `${testId}--content`,
                        xcss: $b9a8b34800c85bdc$var$sectionMessageStyles.contentContainer,
                        children: [
                            !!title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                as: headingLevel,
                                size: "small",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    $b9a8b34800c85bdc$var$sectionMessageStyles.content
                                ]),
                                children: children
                            }),
                            actionsArray.length > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                                shouldWrap: true,
                                testId: testId && `${testId}--actions`,
                                separator: "\xB7",
                                space: "space.100",
                                rowSpace: "space.0",
                                role: actionsArray.length > 1 ? "list" : undefined,
                                xcss: $b9a8b34800c85bdc$var$sectionMessageStyles.actionsContainer,
                                children: actionsArray.map((action, id)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                                        role: actionsArray.length > 1 ? "listitem" : undefined,
                                        children: action
                                    }, id))
                            })
                        ]
                    }),
                    isDismissible && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            $b9a8b34800c85bdc$var$sectionMessageStyles.dismissButtonContainer
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            testId: testId && `${testId}--dismiss-button`,
                            label: "Dismiss",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                            appearance: "subtle",
                            onClick: handleDismiss,
                            spacing: "compact"
                        })
                    })
                ]
            })
        });
        $[5] = Icon;
        $[6] = actionElements;
        $[7] = appearance;
        $[8] = children;
        $[9] = dismissed;
        $[10] = handleDismiss;
        $[11] = headingLevel;
        $[12] = isDismissible;
        $[13] = primaryColor;
        $[14] = ref;
        $[15] = secondaryColor;
        $[16] = testId;
        $[17] = title;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : ({ children: children, appearance: appearance = 'information', actions: actions, title: title, headingLevel: headingLevel = 'h2', icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref)=>{
    const [dismissed, setDismissed] = (0, $cozmU.useState)(false);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $e9d63e901bf3c453$export$e9b82d2e21ac0c1f)(appearance, icon);
    const actionElements = actions && actions.type === (0, $cozmU.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $cozmU.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $8aG6j.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hekY6.default)([
            $b9a8b34800c85bdc$var$sectionMessageStyles.container,
            $b9a8b34800c85bdc$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $b9a8b34800c85bdc$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $b9a8b34800c85bdc$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            as: headingLevel,
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                $b9a8b34800c85bdc$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $b9a8b34800c85bdc$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $b9a8b34800c85bdc$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$b9a8b34800c85bdc$var$SectionMessage.displayName = 'SectionMessage';
var $b9a8b34800c85bdc$export$2e2bcd8739ae039 = $b9a8b34800c85bdc$var$SectionMessage;
module.exports["default"] = $b9a8b34800c85bdc$export$2e2bcd8739ae039;

});

parcelRegister("eY4uS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $bz59w = parcelRequire("bz59w");


var $36CpU = parcelRequire("36CpU");


var $ifxxS = parcelRequire("ifxxS");


var $EOob6 = parcelRequire("EOob6");


var $8D4k8 = parcelRequire("8D4k8");


var $2IHCL = parcelRequire("2IHCL");


var $lzska = parcelRequire("lzska");

const $d6e3ffa94cbe2064$var$SimpleTagComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(49);
    let appearance;
    let href;
    let linkComponent;
    let maxWidth;
    let migration_fallback;
    let rest;
    let swatchBefore;
    let swatchBeforeLabel;
    let swatchBeforeRole;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ appearance: appearance, elemBefore: t1, color: t2, href: href, testId: testId, text: t3, linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = href;
        $[3] = linkComponent;
        $[4] = maxWidth;
        $[5] = migration_fallback;
        $[6] = rest;
        $[7] = swatchBefore;
        $[8] = swatchBeforeLabel;
        $[9] = swatchBeforeRole;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = testId;
    } else {
        appearance = $[1];
        href = $[2];
        linkComponent = $[3];
        maxWidth = $[4];
        migration_fallback = $[5];
        rest = $[6];
        swatchBefore = $[7];
        swatchBeforeLabel = $[8];
        swatchBeforeRole = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        testId = $[13];
    }
    const elemBefore = t1 === undefined ? null : t1;
    const color = t2 === undefined ? "standard" : t2;
    const text = t3 === undefined ? "" : t3;
    if (migration_fallback === "lozenge" && !(0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        let t4;
        if ($[14] !== color) {
            t4 = (0, $2IHCL.getLozengeAppearance)(color);
            $[14] = color;
            $[15] = t4;
        } else t4 = $[15];
        const lozengeAppearance = t4;
        let t5;
        if ($[16] !== lozengeAppearance || $[17] !== rest || $[18] !== testId || $[19] !== text) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                appearance: lozengeAppearance,
                isBold: false,
                testId: testId,
                ...rest,
                children: text
            });
            $[16] = lozengeAppearance;
            $[17] = rest;
            $[18] = testId;
            $[19] = text;
            $[20] = t5;
        } else t5 = $[20];
        return t5;
    }
    if ((0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        const newColor = (0, $bz59w.colorMapping)[color || "standard"];
        let t4;
        if ($[21] !== elemBefore || $[22] !== href || $[23] !== maxWidth || $[24] !== newColor || $[25] !== ref || $[26] !== swatchBefore || $[27] !== swatchBeforeLabel || $[28] !== swatchBeforeRole || $[29] !== testId || $[30] !== text) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $36CpU.default), {
                ref: ref,
                color: newColor,
                text: text,
                elemBefore: elemBefore,
                href: href,
                testId: testId,
                isRemovable: false,
                maxWidth: maxWidth,
                swatchBefore: swatchBefore,
                swatchBeforeLabel: swatchBeforeLabel,
                swatchBeforeRole: swatchBeforeRole
            });
            $[21] = elemBefore;
            $[22] = href;
            $[23] = maxWidth;
            $[24] = newColor;
            $[25] = ref;
            $[26] = swatchBefore;
            $[27] = swatchBeforeLabel;
            $[28] = swatchBeforeRole;
            $[29] = testId;
            $[30] = text;
            $[31] = t4;
        } else t4 = $[31];
        return t4;
    }
    let t4;
    if ($[32] !== color || $[33] !== elemBefore || $[34] !== href || $[35] !== linkComponent || $[36] !== testId || $[37] !== text) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lzska.default), {
            elemBefore: elemBefore,
            isRemovable: false,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent,
            testId: testId
        });
        $[32] = color;
        $[33] = elemBefore;
        $[34] = href;
        $[35] = linkComponent;
        $[36] = testId;
        $[37] = text;
        $[38] = t4;
    } else t4 = $[38];
    const content = t4;
    let t5;
    if ($[39] !== elemBefore) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8D4k8.default), {
            elemBefore: elemBefore
        });
        $[39] = elemBefore;
        $[40] = t5;
    } else t5 = $[40];
    let t6;
    if ($[41] !== appearance || $[42] !== color || $[43] !== content || $[44] !== href || $[45] !== ref || $[46] !== t5 || $[47] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $EOob6.default), {
            ref: ref,
            testId: testId,
            href: href,
            appearance: appearance,
            color: color,
            before: t5,
            contentElement: content
        });
        $[41] = appearance;
        $[42] = color;
        $[43] = content;
        $[44] = href;
        $[45] = ref;
        $[46] = t5;
        $[47] = testId;
        $[48] = t6;
    } else t6 = $[48];
    return t6;
} : ({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, ...rest }, ref)=>{
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $2IHCL.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: text
        });
    } // Use new TagNew component behind feature flag
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $bz59w.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $36CpU.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: false,
            maxWidth: maxWidth,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    } // Original implementation
    const content = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lzska.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $EOob6.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8D4k8.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 *
 * @deprecated `SimpleTag` is deprecated. Use the default `Tag` export from
 * `@atlaskit/tag` with `isRemovable={false}` instead, e.g. `<Tag text="…" isRemovable={false} />`.
 */ const $d6e3ffa94cbe2064$var$SimpleTag = (0, $ifxxS.markAsTagMotionCapable)(/*#__PURE__*/ (0, $cozmU.memo)($d6e3ffa94cbe2064$var$SimpleTagComponent));
var $d6e3ffa94cbe2064$export$2e2bcd8739ae039 = $d6e3ffa94cbe2064$var$SimpleTag;
module.exports["default"] = $d6e3ffa94cbe2064$export$2e2bcd8739ae039;

});

parcelRegister("1glfF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $jALA9 = parcelRequire("jALA9");

const $3f768aaf76917379$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, testId: testId, appearance: t1, spacing: t2, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: t3, isLoading: t4, maxWidth: t5, onClick: t6, style: style, analyticsContext: analyticsContext, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHaspopup, "aria-label": ariaLabel } = t0;
    const appearance = t1 === undefined ? "neutral" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const isSelected = t3 === undefined ? false : t3;
    const isLoading = t4 === undefined ? false : t4;
    const maxWidth = t5 === undefined ? 200 : t5;
    const onClick = t6 === undefined ? (0, $dpsRj.default) : t6;
    let t7;
    if ($[0] !== analyticsContext || $[1] !== appearance || $[2] !== ariaControls || $[3] !== ariaExpanded || $[4] !== ariaHaspopup || $[5] !== ariaLabel || $[6] !== children || $[7] !== iconBefore || $[8] !== interactionName || $[9] !== isLoading || $[10] !== isSelected || $[11] !== maxWidth || $[12] !== onClick || $[13] !== spacing || $[14] !== style || $[15] !== testId || $[16] !== trailingMetric || $[17] !== trailingMetricAppearance) {
        t7 = {
            appearance: appearance,
            spacing: spacing,
            iconBefore: iconBefore,
            trailingMetric: trailingMetric,
            trailingMetricAppearance: trailingMetricAppearance,
            isSelected: isSelected,
            isLoading: isLoading,
            maxWidth: maxWidth,
            style: style,
            testId: testId,
            onClick: onClick,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            children: children,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-label": ariaLabel
        };
        $[0] = analyticsContext;
        $[1] = appearance;
        $[2] = ariaControls;
        $[3] = ariaExpanded;
        $[4] = ariaHaspopup;
        $[5] = ariaLabel;
        $[6] = children;
        $[7] = iconBefore;
        $[8] = interactionName;
        $[9] = isLoading;
        $[10] = isSelected;
        $[11] = maxWidth;
        $[12] = onClick;
        $[13] = spacing;
        $[14] = style;
        $[15] = testId;
        $[16] = trailingMetric;
        $[17] = trailingMetricAppearance;
        $[18] = t7;
    } else t7 = $[18];
    const baseProps = t7;
    let t8;
    if ($[19] !== baseProps || $[20] !== children || $[21] !== ref) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jALA9.default), {
            ref: ref,
            ...baseProps,
            children: children
        });
        $[19] = baseProps;
        $[20] = children;
        $[21] = ref;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'neutral', spacing: spacing = 'default', iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: isSelected = false, isLoading: isLoading = false, maxWidth: maxWidth = 200, onClick: onClick = (0, $dpsRj.default), style: style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jALA9.default), {
        ref: ref,
        ...baseProps,
        children: children
    });
}));
$3f768aaf76917379$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $3f768aaf76917379$export$2e2bcd8739ae039 = $3f768aaf76917379$var$LozengeDropdownTrigger;
module.exports["default"] = $3f768aaf76917379$export$2e2bcd8739ae039;

});

parcelRegister("jLnA6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $882187410a4bd3f0$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $94ddfff62f1faf0d$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'important',
    warningBold: 'default',
    discoveryBold: 'default'
};



var $78t8C = parcelRequire("78t8C");

function $e382c36b5f867002$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $e382c36b5f867002$export$4b844743568d5983(value, max) {
    const safeValue = $e382c36b5f867002$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $e382c36b5f867002$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


const $4c7cec0c7147fc89$var$neutral300 = '#DDDEE1';
const $4c7cec0c7147fc89$var$red300 = '#FD9891';
const $4c7cec0c7147fc89$var$blue300 = '#8FB8F6';
const $4c7cec0c7147fc89$var$neutral1000 = '#292A2E';
const $4c7cec0c7147fc89$var$styles = {
    root: "_0bjKvDcjp5 _2Y7lL41Y8M _3iDTPbccYA _24h04i2Njc _4ouGXINHnM _37wbyuDIqT _3YEZNOdnbC _3L9DPXBY1A",
    added: "_0KLXruzaZe _1UtDYzy7kJ",
    default: "_0KLXru1qiM _1UtDYzDTSe",
    important: "_0KLXruicO2 _1UtDYzDTSe",
    primary: "_0KLXru1tR5 _1UtDYzDTSe",
    primaryInverted: "_0KLXrulfZc _1UtDYzGaer",
    removed: "_0KLXruhH7k _1UtDYzy7kJ"
};
const $4c7cec0c7147fc89$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $e382c36b5f867002$export$4b844743568d5983)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $4c7cec0c7147fc89$var$Badge = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Badge(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { appearance: t1, children: t2, max: t3, style: style, testId: testId } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const children = t2 === undefined ? 0 : t2;
    const max = t3 === undefined ? 99 : t3;
    if ((0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        const newAppearance = (0, $882187410a4bd3f0$export$d21bba0569254935)[appearance];
        let t4;
        if ($[0] !== children || $[1] !== max || $[2] !== newAppearance || $[3] !== style || $[4] !== testId) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $78t8C.default), {
                appearance: newAppearance,
                max: max,
                style: style,
                testId: testId,
                children: children
            });
            $[0] = children;
            $[1] = max;
            $[2] = newAppearance;
            $[3] = style;
            $[4] = testId;
            $[5] = t4;
        } else t4 = $[5];
        return t4;
    }
    const oldAppearance = (0, $94ddfff62f1faf0d$export$16f8cc7ac3541e83)[appearance];
    const t4 = style?.backgroundColor;
    const t5 = style?.color;
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = {
            background: t4,
            color: t5
        };
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const t7 = $4c7cec0c7147fc89$var$styles[oldAppearance];
    let t8;
    if ($[9] !== t7) {
        t8 = (0, $hekY6.default)([
            $4c7cec0c7147fc89$var$styles.root,
            t7
        ]);
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== children || $[12] !== max) {
        t9 = $4c7cec0c7147fc89$var$badgeValueWithNegativeNumberSupported(children, max);
        $[11] = children;
        $[12] = max;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: t9
        });
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t6 || $[18] !== t8 || $[19] !== testId) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t6,
            className: t8,
            children: t10
        });
        $[16] = t10;
        $[17] = t6;
        $[18] = t8;
        $[19] = testId;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $882187410a4bd3f0$export$d21bba0569254935)[appearance];
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $78t8C.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId,
            children: children
        });
    }
    const oldAppearance = (0, $94ddfff62f1faf0d$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $hekY6.default)([
            $4c7cec0c7147fc89$var$styles.root,
            $4c7cec0c7147fc89$var$styles[oldAppearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $4c7cec0c7147fc89$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $4c7cec0c7147fc89$export$2e2bcd8739ae039 = $4c7cec0c7147fc89$var$Badge;
module.exports["default"] = $4c7cec0c7147fc89$export$2e2bcd8739ae039;

});

parcelRegister("RfroO", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7joZr = parcelRequire("7joZr");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");










parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c77aca8e4f3ba2f9$var$actionsStyles = null; /**
                             * __Actions container__
                             *
                             * A container for actions: primary action, secondary action, and tertiary action.
                             *
                             * @internal
                             */ 
const $c77aca8e4f3ba2f9$var$ActionsContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0rIjyk2ADO _0LQT5ES40j"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0rIjyk2ADO _0LQT5ES40j"
        ]),
        children: children
    });
var $c77aca8e4f3ba2f9$export$2e2bcd8739ae039 = $c77aca8e4f3ba2f9$var$ActionsContainer;











parcelRequire("cozmU");




const $0c6e3341fd11324b$var$containerStyles = null; /* Use max-width so the component can shrink on smaller viewports. */ 
const $0c6e3341fd11324b$var$wideContainerStyles = null;
const $0c6e3341fd11324b$var$narrowContainerStyles = null;
const $0c6e3341fd11324b$var$Container = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, width: width, testId: testId } = t0;
    const t1 = width === "narrow" ? "_1EqgXlAef5" : "_1EqgXl0xhY";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_0rIjykp0Oa _43nrzTp0Oa _2xTnZxIZbP _0GTcwRIZbP _2fwxA5DIqT",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            className: t2,
            children: children
        });
        $[2] = children;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0rIjykp0Oa _43nrzTp0Oa _2xTnZxIZbP _0GTcwRIZbP _2fwxA5DIqT",
            width === 'narrow' ? "_1EqgXlAef5" : "_1EqgXl0xhY"
        ]),
        children: children
    });
var $0c6e3341fd11324b$export$2e2bcd8739ae039 = $0c6e3341fd11324b$var$Container;











parcelRequire("cozmU");




const $ec6a35c71b854a48$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $ec6a35c71b854a48$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $ec6a35c71b854a48$var$imageStyles = null; /**
                           * __Image__
                           *
                           * Image in Empty State.
                           *
                           * @internal
                           */ 
const $ec6a35c71b854a48$var$Image = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { maxHeight: maxHeight, maxWidth: maxWidth, height: t1, width: t2, src: src } = t0;
    const height = t1 === undefined ? "auto" : t1;
    const width = t2 === undefined ? "auto" : t2;
    const t3 = `${maxWidth}px`;
    const t4 = `${maxHeight}px`;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = {
            [$ec6a35c71b854a48$var$CSS_VAR_MAX_WIDTH]: t3,
            [$ec6a35c71b854a48$var$CSS_VAR_MAX_HEIGHT]: t4
        };
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = t5;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_3iDTPbvLZJ _1EqgXlbdgD _0NUa3rsFBh _0rIjykNHnM _43nrzTdnbC _2xTnZxIZbP _0GTcwRIZbP"
        ]);
        $[3] = t7;
    } else t7 = $[3];
    let t8;
    if ($[4] !== height || $[5] !== src || $[6] !== t6 || $[7] !== width) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            style: t6,
            width: width,
            height: height,
            alt: "",
            role: "presentation",
            src: src,
            className: t7
        });
        $[4] = height;
        $[5] = src;
        $[6] = t6;
        $[7] = width;
        $[8] = t8;
    } else t8 = $[8];
    return t8;
} : ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        style: {
            [$ec6a35c71b854a48$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$ec6a35c71b854a48$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _1EqgXlbdgD _0NUa3rsFBh _0rIjykNHnM _43nrzTdnbC _2xTnZxIZbP _0GTcwRIZbP"
        ])
    });
var $ec6a35c71b854a48$export$2e2bcd8739ae039 = $ec6a35c71b854a48$var$Image;











parcelRequire("cozmU");




const $476739b82634e4dd$var$spinnerContainerStyles = null; /**
                                      * __Spinner container__
                                      *
                                      * A spinner container for loading state of Empty State.
                                      *
                                      * @internal
                                      */ 
const $476739b82634e4dd$var$SpinnerContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_39xV02NHnM _0GTcwR5zaO"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_39xV02NHnM _0GTcwR5zaO"
        ]),
        children: children
    });
var $476739b82634e4dd$export$2e2bcd8739ae039 = $476739b82634e4dd$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $4388bfb92336558e$var$EmptyState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: t1, headingSize: t2, imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: t3, maxImageWidth: t4, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId } = t0;
    const headingLevel = t1 === undefined ? 4 : t1;
    const headingSize = t2 === undefined ? "medium" : t2;
    const maxImageHeight = t3 === undefined ? 160 : t3;
    const maxImageWidth = t4 === undefined ? 160 : t4;
    let t5;
    if ($[0] !== buttonGroupLabel || $[1] !== isLoading || $[2] !== primaryAction || $[3] !== secondaryAction || $[4] !== testId) {
        t5 = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $c77aca8e4f3ba2f9$export$2e2bcd8739ae039), {
            children: [
                primaryAction && secondaryAction ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7joZr.default), {
                    label: buttonGroupLabel || "Button group",
                    testId: testId && `${testId}-button-group`,
                    children: [
                        secondaryAction,
                        primaryAction
                    ]
                }) : primaryAction || secondaryAction,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $476739b82634e4dd$export$2e2bcd8739ae039), {
                    children: isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        testId: "empty-state-spinner"
                    })
                })
            ]
        }) : null;
        $[0] = buttonGroupLabel;
        $[1] = isLoading;
        $[2] = primaryAction;
        $[3] = secondaryAction;
        $[4] = testId;
        $[5] = t5;
    } else t5 = $[5];
    const actionsContainer = t5;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    const t6 = width || "wide";
    let t7;
    if ($[6] !== imageHeight || $[7] !== imageUrl || $[8] !== imageWidth || $[9] !== maxImageHeight || $[10] !== maxImageWidth || $[11] !== renderImage) {
        t7 = imageUrl ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ec6a35c71b854a48$export$2e2bcd8739ae039), {
            src: imageUrl,
            maxWidth: maxImageWidth,
            maxHeight: maxImageHeight,
            width: imageWidth,
            height: imageHeight
        }) : renderImage && renderImage({
            maxImageWidth: maxImageWidth,
            maxImageHeight: maxImageHeight,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        });
        $[6] = imageHeight;
        $[7] = imageUrl;
        $[8] = imageWidth;
        $[9] = maxImageHeight;
        $[10] = maxImageWidth;
        $[11] = renderImage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== header || $[14] !== headingSize || $[15] !== tag) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            paddingBlockEnd: "space.200",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                size: headingSize,
                as: tag,
                children: header
            })
        });
        $[13] = header;
        $[14] = headingSize;
        $[15] = tag;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== description) {
        t9 = description && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            paddingBlockEnd: "space.300",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                children: description
            })
        });
        $[17] = description;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== actionsContainer || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9 || $[24] !== tertiaryAction || $[25] !== testId) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $0c6e3341fd11324b$export$2e2bcd8739ae039), {
            testId: testId,
            width: t6,
            children: [
                t7,
                t8,
                t9,
                actionsContainer,
                tertiaryAction
            ]
        });
        $[19] = actionsContainer;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
        $[24] = tertiaryAction;
        $[25] = testId;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $c77aca8e4f3ba2f9$export$2e2bcd8739ae039), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7joZr.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $476739b82634e4dd$export$2e2bcd8739ae039), {
                children: isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $0c6e3341fd11324b$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ec6a35c71b854a48$export$2e2bcd8739ae039), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $4388bfb92336558e$export$2e2bcd8739ae039 = $4388bfb92336558e$var$EmptyState;
module.exports["default"] = $4388bfb92336558e$export$2e2bcd8739ae039;

});

parcelRegister("1JERl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dUI0h = parcelRequire("dUI0h");


var $dTHYM = parcelRequire("dTHYM");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $9GVkD = parcelRequire("9GVkD");










parcelRequire("cozmU");





var $1sCHt = parcelRequire("1sCHt");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");

const $16fb7dbe1942111d$var$buttonsContainerStyles = null;
const $16fb7dbe1942111d$var$buttonWrapperBaseStyles = null;
const $16fb7dbe1942111d$var$Buttons = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1mT5xdWVPG _3YEZNOdnbC _2I62gzN91d _1OKFqYdnbC _43nrzTgVvo"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0bjKvDKTcp _2sNsIgmnOE _24h04i2Njc _39xV02Va5s _42Yu6Bbhqd _0KLXruoI2d _2OUyjtGk8v _3Si9701Y8M _3VVnIUoI2d _1og2ZthWTW _0vc7Cr0GoB _1UCI5Fy7kJ"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    const t3 = testId && `${testId}--confirm`;
    let t4;
    if ($[2] !== confirmButtonLabel || $[3] !== onMouseDown || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            tabIndex: -1,
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                type: "submit",
                icon: $16fb7dbe1942111d$var$_temp,
                onMouseDown: onMouseDown,
                label: confirmButtonLabel,
                testId: t3
            })
        });
        $[2] = confirmButtonLabel;
        $[3] = onMouseDown;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_0bjKvDKTcp _2sNsIgmnOE _24h04i2Njc _39xV02Va5s _42Yu6Bbhqd _0KLXruoI2d _2OUyjtGk8v _3Si9701Y8M _3VVnIUoI2d _1og2ZthWTW _0vc7Cr0GoB _1UCI5Fy7kJ"
        ]);
        $[6] = t5;
    } else t5 = $[6];
    const t6 = testId && `${testId}--cancel`;
    let t7;
    if ($[7] !== cancelButtonLabel || $[8] !== onCancelClick || $[9] !== onMouseDown || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            tabIndex: -1,
            className: t5,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                icon: $16fb7dbe1942111d$var$_temp2,
                label: cancelButtonLabel,
                onClick: onCancelClick,
                onMouseDown: onMouseDown,
                testId: t6
            })
        });
        $[7] = cancelButtonLabel;
        $[8] = onCancelClick;
        $[9] = onMouseDown;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t4 || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t1,
            children: [
                t4,
                t7
            ]
        });
        $[12] = t4;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1mT5xdWVPG _3YEZNOdnbC _2I62gzN91d _1OKFqYdnbC _43nrzTgVvo"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                tabIndex: -1,
                className: (0, $hekY6.default)([
                    "_0bjKvDKTcp _2sNsIgmnOE _24h04i2Njc _39xV02Va5s _42Yu6Bbhqd _0KLXruoI2d _2OUyjtGk8v _3Si9701Y8M _3VVnIUoI2d _1og2ZthWTW _0vc7Cr0GoB _1UCI5Fy7kJ"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                tabIndex: -1,
                className: (0, $hekY6.default)([
                    "_0bjKvDKTcp _2sNsIgmnOE _24h04i2Njc _39xV02Va5s _42Yu6Bbhqd _0KLXruoI2d _2OUyjtGk8v _3Si9701Y8M _3VVnIUoI2d _1og2ZthWTW _0vc7Cr0GoB _1UCI5Fy7kJ"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    icon: (iconProps_0)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                            ...iconProps_0,
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $16fb7dbe1942111d$export$2e2bcd8739ae039 = $16fb7dbe1942111d$var$Buttons;
function $16fb7dbe1942111d$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        ...iconProps,
        size: "small"
    });
}
function $16fb7dbe1942111d$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        size: "small"
    });
}





/**
 * Recursively extracts plain text content from a ReactNode.
 *
 * This is useful when a ReactNode needs to be represented as a string,
 * e.g. for use in an `aria-label` attribute.
 */ const $c1a1500fc8431743$var$getTextFromReactNode = (node)=>{
    if (node == null || typeof node === 'boolean') return '';
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($c1a1500fc8431743$var$getTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return $c1a1500fc8431743$var$getTextFromReactNode(node.props.children);
    return '';
};
var $c1a1500fc8431743$export$2e2bcd8739ae039 = $c1a1500fc8431743$var$getTextFromReactNode;











const $263de614280d1a80$var$usePrevious = (value)=>{
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $263de614280d1a80$var$useButtonFocusHook = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isEditing, isEditingState)=>{
    const $ = (0, $bDgLe.c)(10);
    const editButtonRef = (0, $cozmU.useRef)(null);
    const editViewRef = (0, $cozmU.useRef)();
    const preventFocusOnEditButtonRef = (0, $cozmU.useRef)(false);
    const isControlled = typeof isEditing === "undefined";
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $263de614280d1a80$var$usePrevious(shouldBeEditing);
    let t0;
    let t1;
    if ($[0] !== isEditingState) {
        t0 = ()=>{
            if (isEditingState && editViewRef.current) editViewRef.current.focus();
        };
        t1 = [
            editViewRef,
            isEditingState
        ];
        $[0] = isEditingState;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[3] !== prevIsEditing || $[4] !== shouldBeEditing) {
        t2 = ()=>{
            if (prevIsEditing && !shouldBeEditing) {
                if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
                else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
            }
        };
        t3 = [
            prevIsEditing,
            shouldBeEditing
        ];
        $[3] = prevIsEditing;
        $[4] = shouldBeEditing;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>preventFocusOnEditButtonRef.current = true;
        $[7] = t4;
    } else t4 = $[7];
    const doNotFocusOnEditButton = t4;
    let t5;
    if ($[8] !== shouldBeEditing) {
        t5 = {
            editButtonRef: editButtonRef,
            editViewRef: editViewRef,
            shouldBeEditing: shouldBeEditing,
            doNotFocusOnEditButton: doNotFocusOnEditButton
        };
        $[8] = shouldBeEditing;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : (isEditing, isEditingState)=>{
    const editButtonRef = (0, $cozmU.useRef)(null);
    const editViewRef = (0, $cozmU.useRef)();
    const preventFocusOnEditButtonRef = (0, $cozmU.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $263de614280d1a80$var$usePrevious(shouldBeEditing);
    (0, $cozmU.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $cozmU.useEffect)(()=>{
        /**
     * This logic puts the focus on the edit button after confirming using
     * the confirm button or using the keyboard to confirm, but not when
     * it is confirmed by wrapper blur
     */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $263de614280d1a80$export$2e2bcd8739ae039 = $263de614280d1a80$var$useButtonFocusHook;























const $e8c9b359b998ca51$var$readViewContainerStyles = null;
const $e8c9b359b998ca51$var$editButtonStyles = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _2V7sgOdnbC _3hxITiYbGa _3vBAKHjOvk _3iDTPbvLZJ _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _034jHtYbGa _0KLXrujOvk _26BoRw7dHp _4Bd7kAnXvL _2Gb3ncvc3e _3E5jgu6wH8 _1ubuxo98eZ _1NDpvbYbGa _2wtOC9dnbC"
};
const $e8c9b359b998ca51$var$readViewWrapperStyles = null;
const $e8c9b359b998ca51$var$readViewWrapperMotionStyles = null;
const $e8c9b359b998ca51$var$readViewFitContainerWidthStyles = null;
const $e8c9b359b998ca51$var$DRAG_THRESHOLD = 5;
const $e8c9b359b998ca51$var$ReadView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId } = t0;
    const startX = (0, $cozmU.useRef)(0);
    const startY = (0, $cozmU.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (event)=>Math.abs(startX.current - event.clientX) >= $e8c9b359b998ca51$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $e8c9b359b998ca51$var$DRAG_THRESHOLD;
        $[0] = t1;
    } else t1 = $[0];
    const mouseHasMovedAfterMouseDown = t1;
    let t2;
    if ($[1] !== onEditRequested || $[2] !== postReadViewClick) {
        t2 = (event_0)=>{
            const element = event_0.target;
            if (element.tagName.toLowerCase() !== "a" && !mouseHasMovedAfterMouseDown(event_0)) {
                event_0.preventDefault();
                onEditRequested();
                postReadViewClick();
            }
        };
        $[1] = onEditRequested;
        $[2] = postReadViewClick;
        $[3] = t2;
    } else t2 = $[3];
    const onReadViewClick = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_26BoRw7dHp"
        ]);
        $[4] = t3;
    } else t3 = $[4];
    const t4 = testId && `${testId}--edit-button`;
    let t5;
    if ($[5] !== editButtonLabel || $[6] !== editButtonRef || $[7] !== onEditRequested || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            xcss: $e8c9b359b998ca51$var$editButtonStyles.root,
            onClick: onEditRequested,
            ref: editButtonRef,
            testId: t4,
            "aria-label": editButtonLabel
        });
        $[5] = editButtonLabel;
        $[6] = editButtonRef;
        $[7] = onEditRequested;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        };
        $[10] = t6;
    } else t6 = $[10];
    const t7 = readViewFitContainerWidth && "_39xV02N91d";
    let t8;
    if ($[11] !== t7) {
        t8 = (0, $hekY6.default)([
            "_0bjKvDKTcp _23rrnHIpct _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvbI6 _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1eOmH6o126",
            t7,
            (0, $iDrrr.fg)("platform-dst-motion-uplift-button") && "_23rrnHyKLB"
        ]);
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== readView) {
        t9 = readView();
        $[13] = readView;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== onReadViewClick || $[16] !== readViewFitContainerWidth || $[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "presentation",
            onClick: onReadViewClick,
            onMouseDown: t6,
            "data-read-view-fit-container-width": readViewFitContainerWidth,
            className: t8,
            children: t9
        });
        $[15] = onReadViewClick;
        $[16] = readViewFitContainerWidth;
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t5) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t3,
            children: [
                t5,
                t10
            ]
        });
        $[20] = t10;
        $[21] = t5;
        $[22] = t11;
    } else t11 = $[22];
    return t11;
} : ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $cozmU.useRef)(0);
    const startY = (0, $cozmU.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>Math.abs(startX.current - event.clientX) >= $e8c9b359b998ca51$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $e8c9b359b998ca51$var$DRAG_THRESHOLD;
    const onReadViewClick = (event_0)=>{
        const element = event_0.target; /**
                                                      * If a link is clicked in the read view, default action should be taken
                                                      */ 
        if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event_0)) {
            event_0.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_26BoRw7dHp"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                xcss: $e8c9b359b998ca51$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div" /**
         * It is not normally acceptable to add click handlers to non-interactive elements
         * as this is an accessibility anti-pattern. However, because this instance is
         * account for clicking on links that may be embedded within inline-edit and not
         * creating an inaccessible custom element, we can add role="presentation" so that
         * there is no negative impacts to assistive technologies.
         * (Why links are embeeded in inline-edit is for another day...)
         */ , {
                role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $hekY6.default)([
                    "_0bjKvDKTcp _23rrnHIpct _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvbI6 _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1eOmH6o126",
                    readViewFitContainerWidth && "_39xV02N91d",
                    (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && "_23rrnHyKLB"
                ]),
                children: readView()
            })
        ]
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $e8c9b359b998ca51$export$2e2bcd8739ae039 = $e8c9b359b998ca51$var$ReadView;


const $8936718f5adeb429$var$fieldStyles = null;
const $8936718f5adeb429$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8936718f5adeb429$var$InnerInlineEdit = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(56);
    const { startWithEditViewOpen: t0, keepEditViewOpenOnBlur: t1, hideActionButtons: t2, isRequired: t3, readViewFitContainerWidth: t4, editButtonLabel: t5, editLabel: t6, confirmButtonLabel: t7, cancelButtonLabel: t8, defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const startWithEditViewOpen = t0 === undefined ? false : t0;
    const keepEditViewOpenOnBlur = t1 === undefined ? false : t1;
    const hideActionButtons = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const readViewFitContainerWidth = t4 === undefined ? false : t4;
    const editButtonLabel = t5 === undefined ? "Edit" : t5;
    const editLabel = t6 === undefined ? "edit" : t6;
    const confirmButtonLabel = t7 === undefined ? "Confirm" : t7;
    const cancelButtonLabel = t8 === undefined ? "Cancel" : t8;
    const wasFocusReceivedSinceLastBlurRef = (0, $cozmU.useRef)(false);
    const isControlled = typeof isEditing === "undefined";
    const [isEditingState, setEditingState] = (0, $cozmU.useState)(startWithEditViewOpen);
    const timerRef = (0, $cozmU.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $263de614280d1a80$export$2e2bcd8739ae039)(isEditing, isEditingState);
    let t9;
    if ($[0] !== isControlled || $[1] !== providedOnCancel) {
        t9 = ()=>{
            if (isControlled) setEditingState(false);
            providedOnCancel?.();
        };
        $[0] = isControlled;
        $[1] = providedOnCancel;
        $[2] = t9;
    } else t9 = $[2];
    const onCancel = t9;
    let t10;
    if ($[3] !== editViewRef || $[4] !== isControlled || $[5] !== providedOnEdit || $[6] !== shouldBeEditing) {
        t10 = ()=>{
            if (isControlled) setEditingState(true);
            providedOnEdit?.();
            if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
        };
        $[3] = editViewRef;
        $[4] = isControlled;
        $[5] = providedOnEdit;
        $[6] = shouldBeEditing;
        $[7] = t10;
    } else t10 = $[7];
    const onEditRequested = t10;
    let t11;
    if ($[8] !== isControlled || $[9] !== providedOnConfirm) {
        t11 = (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        };
        $[8] = isControlled;
        $[9] = providedOnConfirm;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== analyticsContext || $[12] !== t11) {
        t12 = {
            fn: t11,
            action: "confirmed",
            analyticsData: analyticsContext,
            ...$8936718f5adeb429$var$analyticsAttributes
        };
        $[11] = analyticsContext;
        $[12] = t11;
        $[13] = t12;
    } else t12 = $[13];
    const onConfirm = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[14] !== onCancel) {
        t13 = (event)=>{
            event.preventDefault();
            onCancel();
        };
        $[14] = onCancel;
        $[15] = t13;
    } else t13 = $[15];
    const onCancelClick = t13;
    let t14;
    if ($[16] !== doNotFocusOnEditButton) {
        t14 = (isFieldInvalid, onSubmit, formRef)=>{
            if (typeof formRef === "function") return;
            if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
                doNotFocusOnEditButton();
                if (formRef.current.checkValidity()) onSubmit();
            }
        };
        $[16] = doNotFocusOnEditButton;
        $[17] = t14;
    } else t14 = $[17];
    const tryAutoSubmitWhenBlur = t14;
    let t15;
    if ($[18] !== keepEditViewOpenOnBlur || $[19] !== tryAutoSubmitWhenBlur) {
        t15 = (isFieldInvalid_0, onSubmit_0, formRef_0)=>{
            if (!keepEditViewOpenOnBlur) {
                wasFocusReceivedSinceLastBlurRef.current = false;
                timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid_0, onSubmit_0, formRef_0), 0);
            }
        };
        $[18] = keepEditViewOpenOnBlur;
        $[19] = tryAutoSubmitWhenBlur;
        $[20] = t15;
    } else t15 = $[20];
    const onEditViewWrapperBlur = t15;
    let t16;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            wasFocusReceivedSinceLastBlurRef.current = true;
        };
        $[21] = t16;
    } else t16 = $[21];
    const onEditViewWrapperFocus = t16;
    let t17;
    if ($[22] !== editButtonLabel || $[23] !== editLabel || $[24] !== label) {
        t17 = ()=>{
            if (label) {
                const labelText = typeof label === "string" ? label : (0, $c1a1500fc8431743$export$2e2bcd8739ae039)(label);
                return `${editButtonLabel}, ${labelText}, ${editLabel}`;
            }
            return `${editButtonLabel}, ${editLabel}`;
        };
        $[22] = editButtonLabel;
        $[23] = editLabel;
        $[24] = label;
        $[25] = t17;
    } else t17 = $[25];
    const concatenatedEditButtonLabel = t17;
    let t18;
    if ($[26] !== concatenatedEditButtonLabel || $[27] !== doNotFocusOnEditButton || $[28] !== editButtonRef || $[29] !== onEditRequested || $[30] !== readView || $[31] !== readViewFitContainerWidth || $[32] !== testId) {
        t18 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e8c9b359b998ca51$export$2e2bcd8739ae039), {
                editButtonLabel: concatenatedEditButtonLabel(),
                onEditRequested: onEditRequested,
                postReadViewClick: doNotFocusOnEditButton,
                editButtonRef: editButtonRef,
                readViewFitContainerWidth: readViewFitContainerWidth,
                readView: readView,
                testId: testId
            });
        $[26] = concatenatedEditButtonLabel;
        $[27] = doNotFocusOnEditButton;
        $[28] = editButtonRef;
        $[29] = onEditRequested;
        $[30] = readView;
        $[31] = readViewFitContainerWidth;
        $[32] = testId;
        $[33] = t18;
    } else t18 = $[33];
    const renderReadView = t18;
    let t19;
    if ($[34] !== onConfirm) {
        t19 = (data)=>onConfirm(data.inlineEdit);
        $[34] = onConfirm;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== cancelButtonLabel || $[37] !== confirmButtonLabel || $[38] !== defaultValue || $[39] !== doNotFocusOnEditButton || $[40] !== editView || $[41] !== editViewRef || $[42] !== hideActionButtons || $[43] !== isRequired || $[44] !== label || $[45] !== onCancel || $[46] !== onCancelClick || $[47] !== onEditViewWrapperBlur || $[48] !== renderReadView || $[49] !== shouldBeEditing || $[50] !== testId || $[51] !== validate) {
        t20 = (t21)=>{
            const { formProps: t22, reset: reset } = t21;
            const { onKeyDown: onKeyDown, onSubmit: onSubmit_1, ref: formRef_1 } = t22;
            return /*#__PURE__*/ (0, $8aG6j.jsx)("form", {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === "Esc" || e.key === "Escape") {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit_1,
                ref: formRef_1,
                className: (0, $iDrrr.fg)("platform_design_system_inline_edit_dont_focus") ? "dont-default-focus" : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUI0h.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: (t23)=>{
                        const { fieldProps: fieldProps, error: error } = t23;
                        return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                            onBlur: (e_0)=>{
                                if (!e_0.currentTarget.contains(e_0.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit_1, formRef_1);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $hekY6.default)([
                                "_1EqgXlN91d _1mT5xdRAKS"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $16fb7dbe1942111d$export$2e2bcd8739ae039), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e_1)=>{
                                        reset();
                                        onCancelClick(e_1);
                                    }
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        });
                    }
                }, "edit-view") : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUI0h.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view")
            });
        };
        $[36] = cancelButtonLabel;
        $[37] = confirmButtonLabel;
        $[38] = defaultValue;
        $[39] = doNotFocusOnEditButton;
        $[40] = editView;
        $[41] = editViewRef;
        $[42] = hideActionButtons;
        $[43] = isRequired;
        $[44] = label;
        $[45] = onCancel;
        $[46] = onCancelClick;
        $[47] = onEditViewWrapperBlur;
        $[48] = renderReadView;
        $[49] = shouldBeEditing;
        $[50] = testId;
        $[51] = validate;
        $[52] = t20;
    } else t20 = $[52];
    let t21;
    if ($[53] !== t19 || $[54] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dTHYM.default), {
            onSubmit: t19,
            children: t20
        });
        $[53] = t19;
        $[54] = t20;
        $[55] = t21;
    } else t21 = $[55];
    return t21;
} : (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $cozmU.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $cozmU.useState)(startWithEditViewOpen);
    const timerRef = (0, $cozmU.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $263de614280d1a80$export$2e2bcd8739ae039)(isEditing, isEditingState);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $cozmU.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$8936718f5adeb429$var$analyticsAttributes
    });
    const onCancelClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $cozmU.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        // Ignore if the provided ref is a function. This is used to make the
        // typechecking accurate. Inline edit only uses one type of ref, so this
        // will never trigger.
        if (typeof formRef === 'function') return;
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $cozmU.useCallback)((isFieldInvalid_0, onSubmit_0, formRef_0)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid_0, onSubmit_0, formRef_0), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $cozmU.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) {
            const labelText = typeof label === 'string' ? label : (0, $c1a1500fc8431743$export$2e2bcd8739ae039)(label);
            return `${editButtonLabel}, ${labelText}, ${editLabel}`;
        }
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e8c9b359b998ca51$export$2e2bcd8739ae039), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dTHYM.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit_1, ref: formRef_1 }, reset: reset })=>/*#__PURE__*/ (0, $8aG6j.jsx)("form" /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ , {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit_1,
                ref: formRef_1,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $iDrrr.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUI0h.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                            onBlur: (e_0)=>{
                                if (!e_0.currentTarget.contains(e_0.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit_1, formRef_1);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $hekY6.default)([
                                "_1EqgXlN91d _1mT5xdRAKS"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $16fb7dbe1942111d$export$2e2bcd8739ae039), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e_1)=>{
                                        reset();
                                        onCancelClick(e_1);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view") : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUI0h.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view")
            })
    });
};
const $8936718f5adeb429$var$InlineEdit = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($8936718f5adeb429$var$InnerInlineEdit, {
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)($8936718f5adeb429$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $8936718f5adeb429$export$2e2bcd8739ae039 = $8936718f5adeb429$var$InlineEdit;
module.exports["default"] = $8936718f5adeb429$export$2e2bcd8739ae039;

});

parcelRegister("c0A7H", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $6JrSr = parcelRequire("6JrSr");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $lfoFx = parcelRequire("lfoFx");


var $9GVkD = parcelRequire("9GVkD");










parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $10907fbc9dd67729$var$styles = {
    iconContainer: "_23rrnH0bPn _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdWVPG _2I62gzFQfX",
    iconContainerRegular: "_39xV02ey7F _0jFU0Vey7F",
    iconContainerLarge: "_39xV02SPN1 _0jFU0VSPN1",
    hidden: "_1YKVNsdnbC",
    left: "_3iC0zd4Y4b",
    right: "_1OKFqY4Y4b"
};
const $10907fbc9dd67729$var$IconContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, size: size, isHidden: isHidden, position: position } = t0;
    const t1 = isHidden && $10907fbc9dd67729$var$styles.hidden;
    const t2 = size === "regular" && $10907fbc9dd67729$var$styles.iconContainerRegular;
    const t3 = size === "large" && $10907fbc9dd67729$var$styles.iconContainerLarge;
    const t4 = position === "left" && $10907fbc9dd67729$var$styles.left;
    const t5 = position === "right" && $10907fbc9dd67729$var$styles.right;
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
        t6 = (0, $w6R6I.cx)($10907fbc9dd67729$var$styles.iconContainer, t1, t2, t3, t4, t5);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== children || $[7] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: t6,
            children: children
        });
        $[6] = children;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
} : ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($10907fbc9dd67729$var$styles.iconContainer, isHidden && $10907fbc9dd67729$var$styles.hidden, size === 'regular' && $10907fbc9dd67729$var$styles.iconContainerRegular, size === 'large' && $10907fbc9dd67729$var$styles.iconContainerLarge, position === 'left' && $10907fbc9dd67729$var$styles.left, position === 'right' && $10907fbc9dd67729$var$styles.right),
        children: children
    });
};
var $10907fbc9dd67729$export$2e2bcd8739ae039 = $10907fbc9dd67729$var$IconContainer;


const $9fa89ee46784739b$var$LOADING_LABEL = ', Loading';
const $9fa89ee46784739b$var$baseStyles = null;
const $9fa89ee46784739b$var$sizeStyles = {
    regular: "_0bjKvDS5Zs _0jFU0V5zaO _39xV02Va5s _1lBcDc8HPE _3ScelFxpxF",
    large: "_0bjKvDS5Zs _0jFU0VkG2W _39xV02S40j _1lBcDc5zaO _3ScelFey7F"
}; /**
    * Slider knob translate transforms per size, applied when checked.
    */ 
const $9fa89ee46784739b$var$checkedSliderStyles = {
    regular: "_0ue2N5PEJV",
    large: "_0ue2N54isG"
}; /**
    * Applied when the toggle is checked
    */ 
const $9fa89ee46784739b$var$checkedStyles = null; /**
                             * Applied when the toggle is checked and not disabled.
                             */ 
const $9fa89ee46784739b$var$checkedHoveredStyles = null; /**
                                    * Applied when the toggle is unchecked and not disabled.
                                    */ 
const $9fa89ee46784739b$var$uncheckedHoveredStyles = null; /**
                                      * Applied when the toggle is disabled.
                                      */ 
const $9fa89ee46784739b$var$disabledStyles = null;
const $9fa89ee46784739b$var$inputStyles = null;
const $9fa89ee46784739b$var$noop = (0, $dpsRj.default);
const $9fa89ee46784739b$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $9fa89ee46784739b$var$Toggle = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(65);
    const { defaultChecked: t0, isDisabled: t1, onBlur: t2, onChange: t3, onFocus: t4, size: t5, name: t6, value: t7, isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const defaultChecked = t0 === undefined ? false : t0;
    const isDisabled = t1 === undefined ? false : t1;
    const providedOnBlur = t2 === undefined ? $9fa89ee46784739b$var$noop : t2;
    const providedChange = t3 === undefined ? $9fa89ee46784739b$var$noop : t3;
    const providedFocus = t4 === undefined ? $9fa89ee46784739b$var$noop : t4;
    const size = t5 === undefined ? "regular" : t5;
    const name = t6 === undefined ? "" : t6;
    const value = t7 === undefined ? "" : t7;
    const isControlled = typeof isChecked === "undefined";
    const [checked, setChecked] = (0, $cozmU.useState)(defaultChecked);
    const loadingLabelId = (0, $6JrSr.useId)();
    let t8;
    if ($[0] !== analyticsContext || $[1] !== providedOnBlur) {
        t8 = {
            fn: providedOnBlur,
            action: "blur",
            analyticsData: analyticsContext,
            ...$9fa89ee46784739b$var$analyticsAttributes
        };
        $[0] = analyticsContext;
        $[1] = providedOnBlur;
        $[2] = t8;
    } else t8 = $[2];
    const handleBlur = (0, $7r5Hr.usePlatformLeafEventHandler)(t8);
    let t9;
    if ($[3] !== analyticsContext || $[4] !== providedFocus) {
        t9 = {
            fn: providedFocus,
            action: "focus",
            analyticsData: analyticsContext,
            ...$9fa89ee46784739b$var$analyticsAttributes
        };
        $[3] = analyticsContext;
        $[4] = providedFocus;
        $[5] = t9;
    } else t9 = $[5];
    const handleFocus = (0, $7r5Hr.usePlatformLeafEventHandler)(t9);
    let t10;
    if ($[6] !== isControlled || $[7] !== providedChange) {
        t10 = (event, analyticsEvent)=>{
            if (isControlled) setChecked($9fa89ee46784739b$var$_temp);
            return providedChange(event, analyticsEvent);
        };
        $[6] = isControlled;
        $[7] = providedChange;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== analyticsContext || $[10] !== t10) {
        t11 = {
            fn: t10,
            action: "change",
            analyticsData: analyticsContext,
            ...$9fa89ee46784739b$var$analyticsAttributes
        };
        $[9] = analyticsContext;
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const handleChange = (0, $7r5Hr.usePlatformLeafEventHandler)(t11);
    const shouldChecked = isControlled ? checked : isChecked;
    const labelId = (0, $6JrSr.useId)();
    const t12 = $9fa89ee46784739b$var$sizeStyles[size];
    const t13 = shouldChecked && "_0KLXruhbjP";
    const t14 = shouldChecked && $9fa89ee46784739b$var$checkedSliderStyles[size];
    const t15 = !isDisabled && shouldChecked && "_1eOmH61YDn";
    const t16 = !isDisabled && !shouldChecked && "_1eOmH6kTlo";
    const t17 = isDisabled && "_0KLXruVrZW _1UtDYzoM2E _0wOv4Qsyl5";
    let t18;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14 || $[15] !== t15 || $[16] !== t16 || $[17] !== t17) {
        t18 = (0, $hekY6.default)([
            "_3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvbI6 _24h04iPvdi _1mT5xdRAKS _07XDTDPvdi _0KLXrugozt _1UtDYz6BYM _0wOv4Q7zJH _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoFQfX _46hvQmFQfX _03SyCPFQfX _0LQT5EFQfX _3Z9K0wLrT7 _1kOSYtC67X _0qk6IKjwM9 _1OimfuaaQb _3dCYwDWVPG _4diMdq6BYM _3Ku51Iogpp _3p3AmIUNDJ _2jTvwtUNDJ _3cg1YiLrT7 _1LAndJC67X _1usDfMjwM9 _4FDQORnXvL _1jazCKvc3e _2P1GNwO6nV _1cgPff7iY9",
            t12,
            t13,
            t14,
            t15,
            t16,
            t17
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
        $[16] = t16;
        $[17] = t17;
        $[18] = t18;
    } else t18 = $[18];
    let t19;
    if ($[19] !== isLoading || $[20] !== label || $[21] !== labelId) {
        t19 = label ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            id: labelId,
            hidden: true,
            children: isLoading ? `${label}${$9fa89ee46784739b$var$LOADING_LABEL}` : label
        }) : null;
        $[19] = isLoading;
        $[20] = label;
        $[21] = labelId;
        $[22] = t19;
    } else t19 = $[22];
    const t20 = testId && `${testId}--input`;
    const t21 = isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined;
    let t22;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKYbGa _1YKVNsdnbC _1zr6DcxTF4 _0htemXOiJt _067LcefKqY"
        ]);
        $[23] = t22;
    } else t22 = $[23];
    let t23;
    if ($[24] !== descriptionId || $[25] !== handleBlur || $[26] !== handleChange || $[27] !== handleFocus || $[28] !== id || $[29] !== isDisabled || $[30] !== name || $[31] !== ref || $[32] !== shouldChecked || $[33] !== t20 || $[34] !== t21 || $[35] !== value) {
        t23 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": t20,
            "aria-labelledby": t21,
            "aria-describedby": descriptionId,
            className: t22
        });
        $[24] = descriptionId;
        $[25] = handleBlur;
        $[26] = handleChange;
        $[27] = handleFocus;
        $[28] = id;
        $[29] = isDisabled;
        $[30] = name;
        $[31] = ref;
        $[32] = shouldChecked;
        $[33] = t20;
        $[34] = t21;
        $[35] = value;
        $[36] = t23;
    } else t23 = $[36];
    const t24 = !shouldChecked;
    let t25;
    if ($[37] !== isLoading || $[38] !== shouldChecked || $[39] !== testId) {
        t25 = isLoading && shouldChecked ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "xsmall",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "currentColor",
            testId: testId && `${testId}--toggle-check-icon`,
            size: "small"
        });
        $[37] = isLoading;
        $[38] = shouldChecked;
        $[39] = testId;
        $[40] = t25;
    } else t25 = $[40];
    let t26;
    if ($[41] !== size || $[42] !== t24 || $[43] !== t25) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10907fbc9dd67729$export$2e2bcd8739ae039), {
            size: size,
            isHidden: t24,
            position: "left",
            children: t25
        });
        $[41] = size;
        $[42] = t24;
        $[43] = t25;
        $[44] = t26;
    } else t26 = $[44];
    let t27;
    if ($[45] !== isLoading || $[46] !== shouldChecked || $[47] !== testId) {
        t27 = isLoading && !shouldChecked ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "xsmall",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: "",
            color: "currentColor",
            testId: testId && `${testId}--toggle-cross-icon`,
            size: "small"
        });
        $[45] = isLoading;
        $[46] = shouldChecked;
        $[47] = testId;
        $[48] = t27;
    } else t27 = $[48];
    let t28;
    if ($[49] !== shouldChecked || $[50] !== size || $[51] !== t27) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10907fbc9dd67729$export$2e2bcd8739ae039), {
            size: size,
            isHidden: shouldChecked,
            position: "right",
            children: t27
        });
        $[49] = shouldChecked;
        $[50] = size;
        $[51] = t27;
        $[52] = t28;
    } else t28 = $[52];
    let t29;
    if ($[53] !== isLoading || $[54] !== label || $[55] !== loadingLabelId) {
        t29 = isLoading && !label && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            id: loadingLabelId,
            children: $9fa89ee46784739b$var$LOADING_LABEL
        });
        $[53] = isLoading;
        $[54] = label;
        $[55] = loadingLabelId;
        $[56] = t29;
    } else t29 = $[56];
    let t30;
    if ($[57] !== t18 || $[58] !== t19 || $[59] !== t23 || $[60] !== t26 || $[61] !== t28 || $[62] !== t29 || $[63] !== testId) {
        t30 = /*#__PURE__*/ (0, $8aG6j.jsxs)("label", {
            "data-testid": testId,
            className: t18,
            children: [
                t19,
                t23,
                t26,
                t28,
                t29
            ]
        });
        $[57] = t18;
        $[58] = t19;
        $[59] = t23;
        $[60] = t26;
        $[61] = t28;
        $[62] = t29;
        $[63] = testId;
        $[64] = t30;
    } else t30 = $[64];
    return t30;
} : (props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $9fa89ee46784739b$var$noop, onChange: providedChange = $9fa89ee46784739b$var$noop, onFocus: providedFocus = $9fa89ee46784739b$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $cozmU.useState)(defaultChecked);
    const loadingLabelId = (0, $6JrSr.useId)();
    const handleBlur = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$9fa89ee46784739b$var$analyticsAttributes
    });
    const handleFocus = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$9fa89ee46784739b$var$analyticsAttributes
    });
    const handleChange = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked_0)=>!checked_0);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$9fa89ee46784739b$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const labelId = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("label", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvbI6 _24h04iPvdi _1mT5xdRAKS _07XDTDPvdi _0KLXrugozt _1UtDYz6BYM _0wOv4Q7zJH _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoFQfX _46hvQmFQfX _03SyCPFQfX _0LQT5EFQfX _3Z9K0wLrT7 _1kOSYtC67X _0qk6IKjwM9 _1OimfuaaQb _3dCYwDWVPG _4diMdq6BYM _3Ku51Iogpp _3p3AmIUNDJ _2jTvwtUNDJ _3cg1YiLrT7 _1LAndJC67X _1usDfMjwM9 _4FDQORnXvL _1jazCKvc3e _2P1GNwO6nV _1cgPff7iY9",
            $9fa89ee46784739b$var$sizeStyles[size],
            shouldChecked && "_0KLXruhbjP",
            shouldChecked && $9fa89ee46784739b$var$checkedSliderStyles[size],
            !isDisabled && shouldChecked && "_1eOmH61YDn",
            !isDisabled && !shouldChecked && "_1eOmH6kTlo",
            isDisabled && "_0KLXruVrZW _1UtDYzoM2E _0wOv4Qsyl5"
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$9fa89ee46784739b$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId,
                className: (0, $hekY6.default)([
                    "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKYbGa _1YKVNsdnbC _1zr6DcxTF4 _0htemXOiJt _067LcefKqY"
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10907fbc9dd67729$export$2e2bcd8739ae039), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10907fbc9dd67729$export$2e2bcd8739ae039), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                id: loadingLabelId,
                children: $9fa89ee46784739b$var$LOADING_LABEL
            })
        ]
    });
}));
$9fa89ee46784739b$var$Toggle.displayName = 'Toggle';
var $9fa89ee46784739b$export$2e2bcd8739ae039 = $9fa89ee46784739b$var$Toggle;
function $9fa89ee46784739b$var$_temp(checked_0) {
    return !checked_0;
}
module.exports["default"] = $9fa89ee46784739b$export$2e2bcd8739ae039;

});

parcelRegister("3Una5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $d2UzA = parcelRequire("d2UzA");


var $iDrrr = parcelRequire("iDrrr");


var $jE4FX = parcelRequire("jE4FX");


var $kMm3u = parcelRequire("kMm3u");


var $ifxxS = parcelRequire("ifxxS");


var $fc5bD = parcelRequire("fc5bD");


var $8dYJC = parcelRequire("8dYJC");


var $4ea0k = parcelRequire("4ea0k");


var $7tNhr = parcelRequire("7tNhr");


var $hPeTN = parcelRequire("hPeTN");

const $120f92d055b9cbfe$var$styles = {
    baseStyles: "_2mHwu8FQfX _0bjKvDS5Zs _2sNsIg7NXe _3hxITi6wH8 _2V7sgONvrM _4c065UPgdg _3SamIH1Y8M _2YLqiK1Y8M _3iDTPbccYA _24h04i2Njc _4ouGXIdnbC _1EqgXl6zFX _0jFU0VkG2W _1mT5xdRAKS _0hPCNLDIqT _1RrJLit2nV _0KLXru66of _1UtDYzy7kJ _0wOv4Q18ZR _03SyCPZimw _0LQT5EPgdg _4bBlWPLRg7",
    noMarginStyles: "_3SamIHPgdg _2YLqiKPgdg",
    otherBaseStyles: "_0bjKvDKxmn _03SyCP1Y8M",
    agentBaseStyles: "_0bjKvDKxmn _03SyCP1Y8M",
    removableStyles: "_03SyCP4Y4b _4ouGXIF6tL",
    userRemovableStyles: "_03SyCP4Y4b _4ouGXIF6tL",
    avatarStyles: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _0GTcwRA17z",
    otherAvatarStyles: "_0bjKvDKxmn",
    agentAvatarStyles: "_0bjKvDdnbC",
    textStyles: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1ANEUSLRg7 _4ouGXIdnbC _1UtDYzy7kJ",
    textEllipsis: "_39HuIbz8Lp",
    textClip: "_39HuIboWuR",
    afterStyles: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT _1pp6NdIZbP _0GTcwRFQfX _1mT5xdRAKS",
    afterMotionStyles: "_4ouGXI8HPE",
    verifiedIconStyles: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _1UtDYzXb4z _0GTcwRHZdu",
    focusRingStyles: "_4EiLyUXzJH _34b3D2FQfX",
    childFocusRingStyles: "_32BiAhXzJH _3e6OgrFQfX",
    interactiveBaseStyles: "_0wOv4Q7zJH _00RXbRFQfX _0luBOg98eZ _2h5UOzYbGa _3W2WEt6wH8 _4nTk44nQyn _1YaocbnQyn _1iQ2bjxTF4 _4F265UOiJt _4CEokifKqY _3yxFfFccYA _0sfB8dDIqT _3HSZmVdnbC _0gKGiehR7j _1jqEDxOiJt _3bFj0ThR7j _2nDb5UxTF4 _2hcEyKOiJt _18ofVPfKqY _0DlTgX98eZ _27PHXJYbGa _2IWu1s6wH8 _1jzgdmOiJt",
    interactiveHoverStyles: "_12Ap2v98eZ _4pTqUo0Rl6 _2yW01O6wH8 _1eOmH6o126 _1E1xWzhR7j _3gzVzLN4oS",
    interactiveMotionStyles: "_23rrnHyKLB _3sFUREiSCN",
    activeMotionStyles: "_4bt5LAnQyn _2WAcuGnQyn"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ // Border color style - gray only for AvatarTag.
// Uses the new color.border.accent.gray.subtle token directly so no OKLCH/color-mix
// runtime transforms are needed.
const $120f92d055b9cbfe$var$borderColorStyles = {
    root: "_2ssR4FiXlq"
}; // Border filter styles - base state
const $120f92d055b9cbfe$var$borderFilterStyles = {
    root: "_3vBAKHvQ39"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
/**
 * __AvatarTag__
 *
 * AvatarTag is a specialized tag for representing people, teams/other entities, or agents with an avatar and name.
 * The visual appearance (round, square, or hexagonal) is determined by the `type` prop.
 */ const $120f92d055b9cbfe$var$AvatarTagComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function AvatarTag(t0, ref) {
    const $ = (0, $bDgLe.c)(44);
    let AvatarComponent;
    let href;
    let isVerified;
    let linkComponent;
    let maxWidth;
    let onAfterRemoveAction;
    let onBeforeRemoveAction;
    let onClick;
    let other;
    let removeButtonLabel;
    let t1;
    let t2;
    let testId;
    let text;
    let type;
    if ($[0] !== t0) {
        ({ text: text, type: type, avatar: AvatarComponent, href: href, linkComponent: linkComponent, isRemovable: t1, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, isVerified: isVerified, maxWidth: maxWidth, hasMargin: t2, onClick: onClick, ...other } = t0);
        $[0] = t0;
        $[1] = AvatarComponent;
        $[2] = href;
        $[3] = isVerified;
        $[4] = linkComponent;
        $[5] = maxWidth;
        $[6] = onAfterRemoveAction;
        $[7] = onBeforeRemoveAction;
        $[8] = onClick;
        $[9] = other;
        $[10] = removeButtonLabel;
        $[11] = t1;
        $[12] = t2;
        $[13] = testId;
        $[14] = text;
        $[15] = type;
    } else {
        AvatarComponent = $[1];
        href = $[2];
        isVerified = $[3];
        linkComponent = $[4];
        maxWidth = $[5];
        onAfterRemoveAction = $[6];
        onBeforeRemoveAction = $[7];
        onClick = $[8];
        other = $[9];
        removeButtonLabel = $[10];
        t1 = $[11];
        t2 = $[12];
        testId = $[13];
        text = $[14];
        type = $[15];
    }
    const isRemovable = t1 === undefined ? true : t1;
    const hasMargin = t2 === undefined ? true : t2;
    const isMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-labels");
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $hPeTN.useTagRemoval)(onBeforeRemoveAction);
    let t3;
    if ($[16] !== onAfterRemoveAction || $[17] !== text) {
        t3 = ()=>{
            onAfterRemoveAction?.(text);
        };
        $[16] = onAfterRemoveAction;
        $[17] = text;
        $[18] = t3;
    } else t3 = $[18];
    const onShrinkOutExitComplete = t3;
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $4ea0k.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $8dYJC.useButtonInteraction)();
    const isOtherType = type === "other";
    const isAgentType = type === "agent";
    const isUserType = type === "user";
    const showVerified = isOtherType && isVerified;
    const avatarAppearance = isUserType ? "circle" : isAgentType ? "hexagon" : "square";
    const removeButtonShape = isUserType ? "circle" : "default";
    let t4;
    if ($[19] !== buttonHandlers || $[20] !== handleRemoveRequest || $[21] !== isRemovable || $[22] !== onKeyPress || $[23] !== removeButtonLabel || $[24] !== removeButtonShape || $[25] !== removingTag || $[26] !== showingTag || $[27] !== testId || $[28] !== text) {
        t4 = {
            isRemovable: isRemovable,
            tagText: text,
            removeButtonLabel: removeButtonLabel,
            testId: testId,
            handleRemoveRequest: handleRemoveRequest,
            removingTag: removingTag,
            showingTag: showingTag,
            onKeyPress: onKeyPress,
            shape: removeButtonShape,
            buttonHandlers: buttonHandlers
        };
        $[19] = buttonHandlers;
        $[20] = handleRemoveRequest;
        $[21] = isRemovable;
        $[22] = onKeyPress;
        $[23] = removeButtonLabel;
        $[24] = removeButtonShape;
        $[25] = removingTag;
        $[26] = showingTag;
        $[27] = testId;
        $[28] = text;
        $[29] = t4;
    } else t4 = $[29];
    const removeButton = (0, $7tNhr.useRemoveButton)(t4);
    let t5;
    if ($[30] !== avatarAppearance) {
        t5 = {
            size: "xxsmall",
            appearance: avatarAppearance,
            borderColor: "transparent"
        };
        $[30] = avatarAppearance;
        $[31] = t5;
    } else t5 = $[31];
    const controlledProps = t5;
    const AvatarComponentTyped = AvatarComponent;
    let t6;
    if ($[32] !== AvatarComponentTyped || $[33] !== controlledProps) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponentTyped, {
            ...controlledProps
        });
        $[32] = AvatarComponentTyped;
        $[33] = controlledProps;
        $[34] = t6;
    } else t6 = $[34];
    const rendered = t6;
    let t7;
    if ($[35] !== controlledProps || $[36] !== rendered) {
        t7 = /*#__PURE__*/ (0, $cozmU.isValidElement)(rendered) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(rendered, controlledProps) : rendered;
        $[35] = controlledProps;
        $[36] = rendered;
        $[37] = t7;
    } else t7 = $[37];
    const avatarElement = t7;
    const renderTagContent = (tagRef, t8, t9, t10)=>{
        const isEntering = t8 === undefined ? false : t8;
        const isExiting = t9 === undefined ? false : t9;
        const hasEllipsis = t10 === undefined ? null : t10;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            ...other,
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $hekY6.default)([
                $120f92d055b9cbfe$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $120f92d055b9cbfe$var$styles.noMarginStyles,
                isOtherType && $120f92d055b9cbfe$var$styles.otherBaseStyles,
                isAgentType && $120f92d055b9cbfe$var$styles.agentBaseStyles,
                $120f92d055b9cbfe$var$borderColorStyles.root,
                $120f92d055b9cbfe$var$borderFilterStyles.root,
                isLink && $120f92d055b9cbfe$var$styles.interactiveBaseStyles,
                isLink && $120f92d055b9cbfe$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $120f92d055b9cbfe$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $120f92d055b9cbfe$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $120f92d055b9cbfe$var$styles.interactiveHoverStyles,
                isRemovable && !isUserType && $120f92d055b9cbfe$var$styles.removableStyles,
                isRemovable && isUserType && $120f92d055b9cbfe$var$styles.userRemovableStyles,
                isLinkFocused && !isButtonFocused && $120f92d055b9cbfe$var$styles.childFocusRingStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $jE4FX.LinkWrapper), {
                    isLink: isLink,
                    href: href,
                    LinkComponent: LinkComponent,
                    testId: testId,
                    linkHandlers: linkHandlers,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $120f92d055b9cbfe$var$styles.avatarStyles,
                                isOtherType && $120f92d055b9cbfe$var$styles.otherAvatarStyles,
                                isAgentType && $120f92d055b9cbfe$var$styles.agentAvatarStyles
                            ]),
                            children: avatarElement
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-tag-text": true,
                            className: (0, $hekY6.default)([
                                $120f92d055b9cbfe$var$styles.textStyles,
                                hasEllipsis === false ? $120f92d055b9cbfe$var$styles.textClip : $120f92d055b9cbfe$var$styles.textEllipsis
                            ]),
                            children: text
                        })
                    ]
                }),
                showVerified && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $120f92d055b9cbfe$var$styles.verifiedIconStyles
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                        label: "Verified",
                        size: "small"
                    })
                }),
                removeButton && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $120f92d055b9cbfe$var$styles.afterStyles,
                        isMotionEnabled && $120f92d055b9cbfe$var$styles.afterMotionStyles
                    ]),
                    children: !isExiting && removeButton
                })
            ]
        });
    };
    if (isMotionEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc5bD.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status,
        children: (t11)=>{
            const { hasEllipsis: hasEllipsis_0, isEntering: isEntering_0, isExiting: isExiting_0, ref: motionRef } = t11;
            return renderTagContent(motionRef, isEntering_0, isExiting_0, hasEllipsis_0);
        }
    });
    const T0 = (0, $kMm3u.RemovableWrapper);
    const t11 = isRemovable ? onShrinkOutExitComplete : undefined;
    const t12 = renderTagContent(ref);
    let t13;
    if ($[38] !== T0 || $[39] !== isRemovable || $[40] !== status || $[41] !== t11 || $[42] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)(T0, {
            isRemovable: isRemovable,
            status: status,
            onShrinkOutExitComplete: t11,
            children: t12
        });
        $[38] = T0;
        $[39] = isRemovable;
        $[40] = status;
        $[41] = t11;
        $[42] = t12;
        $[43] = t13;
    } else t13 = $[43];
    return t13;
} : function AvatarTag({ text: text, type: type, avatar: AvatarComponent, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, isVerified: isVerified, maxWidth: // Shows verified icon for 'other' type tags
maxWidth, hasMargin: hasMargin = true, onClick: onClick, ...other }, ref) {
    const isMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-labels');
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $hPeTN.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $cozmU.useCallback)(()=>{
        onAfterRemoveAction?.(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $4ea0k.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $8dYJC.useButtonInteraction)(); // Determine styles based on type
    const isOtherType = type === 'other';
    const isAgentType = type === 'agent';
    const isUserType = type === 'user'; // isVerified is only available for 'other' type
    const showVerified = isOtherType && isVerified; // Determine avatar appearance based on type
    const avatarAppearance = isUserType ? 'circle' : isAgentType ? 'hexagon' : 'square'; // Determine remove button shape based on type
    const removeButtonShape = isUserType ? 'circle' : 'default';
    const removeButton = (0, $7tNhr.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        shape: removeButtonShape,
        buttonHandlers: buttonHandlers
    }); // Render the avatar with controlled props, then clone so our props are applied
    const controlledProps = {
        size: 'xxsmall',
        appearance: avatarAppearance,
        borderColor: 'transparent'
    };
    const AvatarComponentTyped = AvatarComponent;
    const rendered = /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponentTyped, {
        ...controlledProps
    });
    const avatarElement = // eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, $cozmU.isValidElement)(rendered) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(rendered, controlledProps) : rendered;
    const renderTagContent = (tagRef, isEntering = false, isExiting = false, hasEllipsis = null)=>/*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            ...other,
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $hekY6.default)([
                $120f92d055b9cbfe$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $120f92d055b9cbfe$var$styles.noMarginStyles,
                isOtherType && $120f92d055b9cbfe$var$styles.otherBaseStyles,
                isAgentType && $120f92d055b9cbfe$var$styles.agentBaseStyles,
                $120f92d055b9cbfe$var$borderColorStyles.root,
                $120f92d055b9cbfe$var$borderFilterStyles.root,
                isLink && $120f92d055b9cbfe$var$styles.interactiveBaseStyles,
                isLink && $120f92d055b9cbfe$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $120f92d055b9cbfe$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $120f92d055b9cbfe$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $120f92d055b9cbfe$var$styles.interactiveHoverStyles,
                isRemovable && !isUserType && $120f92d055b9cbfe$var$styles.removableStyles,
                isRemovable && isUserType && $120f92d055b9cbfe$var$styles.userRemovableStyles,
                isLinkFocused && !isButtonFocused && $120f92d055b9cbfe$var$styles.childFocusRingStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $jE4FX.LinkWrapper), {
                    isLink: isLink,
                    href: href,
                    LinkComponent: LinkComponent,
                    testId: testId,
                    linkHandlers: linkHandlers,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $120f92d055b9cbfe$var$styles.avatarStyles,
                                isOtherType && $120f92d055b9cbfe$var$styles.otherAvatarStyles,
                                isAgentType && $120f92d055b9cbfe$var$styles.agentAvatarStyles
                            ]),
                            children: avatarElement
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-tag-text": true,
                            className: (0, $hekY6.default)([
                                $120f92d055b9cbfe$var$styles.textStyles,
                                hasEllipsis === false ? $120f92d055b9cbfe$var$styles.textClip : $120f92d055b9cbfe$var$styles.textEllipsis
                            ]),
                            children: text
                        })
                    ]
                }),
                showVerified && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $120f92d055b9cbfe$var$styles.verifiedIconStyles
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                        label: "Verified",
                        size: "small"
                    })
                }),
                removeButton && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $120f92d055b9cbfe$var$styles.afterStyles,
                        isMotionEnabled && $120f92d055b9cbfe$var$styles.afterMotionStyles
                    ]),
                    children: !isExiting && removeButton
                })
            ]
        });
    if (isMotionEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc5bD.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status,
        children: ({ hasEllipsis: hasEllipsis_0, isEntering: isEntering_0, isExiting: isExiting_0, ref: motionRef })=>renderTagContent(motionRef, isEntering_0, isExiting_0, hasEllipsis_0)
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kMm3u.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: renderTagContent(ref)
    });
}); /**
     * __Avatar tag__
     */ 
const $120f92d055b9cbfe$var$AvatarTag = (0, $ifxxS.markAsTagMotionCapable)(/*#__PURE__*/ (0, $cozmU.memo)($120f92d055b9cbfe$var$AvatarTagComponent));
var $120f92d055b9cbfe$export$2e2bcd8739ae039 = $120f92d055b9cbfe$var$AvatarTag;
module.exports["default"] = $120f92d055b9cbfe$export$2e2bcd8739ae039;

});

parcelRegister("jtT80", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $f772478f2a45b68d$var$styles = {
    common: "_2sNsIgmnOE",
    anchor: "_1kk5Tku7m9",
    pressable: "_0bjKvDcjp5 _1UtDYzM7Tp _1kk5Tkf7mX _0KLXrujOvk _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _0CMRbkAwSC"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $f772478f2a45b68d$var$SectionMessageAction = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(28);
    const { children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target } = t0;
    if (!linkComponent) {
        if (href) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = (0, $hekY6.default)([
                    $f772478f2a45b68d$var$styles.common,
                    $f772478f2a45b68d$var$styles.anchor
                ]);
                $[0] = t1;
            } else t1 = $[0];
            const t2 = ref;
            let t3;
            if ($[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== t2 || $[5] !== target || $[6] !== testId) {
                t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                    testId: testId,
                    onClick: onClick,
                    href: href,
                    target: target,
                    ref: t2,
                    children: children
                });
                $[1] = children;
                $[2] = href;
                $[3] = onClick;
                $[4] = t2;
                $[5] = target;
                $[6] = testId;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== t1 || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: t1,
                    children: t3
                });
                $[8] = t1;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        }
        if (onClick) {
            let t1;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = (0, $w6R6I.cx)($f772478f2a45b68d$var$styles.common, $f772478f2a45b68d$var$styles.pressable);
                $[11] = t1;
            } else t1 = $[11];
            const t2 = ref;
            let t3;
            if ($[12] !== children || $[13] !== onClick || $[14] !== t2 || $[15] !== testId) {
                t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    testId: testId,
                    onClick: onClick,
                    xcss: t1,
                    ref: t2,
                    children: children
                });
                $[12] = children;
                $[13] = onClick;
                $[14] = t2;
                $[15] = testId;
                $[16] = t3;
            } else t3 = $[16];
            return t3;
        }
        let t1;
        if ($[17] !== children || $[18] !== ref || $[19] !== testId) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                testId: testId,
                xcss: $f772478f2a45b68d$var$styles.common,
                ref: ref,
                children: children
            });
            $[17] = children;
            $[18] = ref;
            $[19] = testId;
            $[20] = t1;
        } else t1 = $[20];
        return t1;
    }
    let t1;
    if ($[21] !== children || $[22] !== href || $[23] !== linkComponent || $[24] !== onClick || $[25] !== ref || $[26] !== testId) {
        t1 = onClick || href ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined,
            ref: ref,
            children: children
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
            children: children
        });
        $[21] = children;
        $[22] = href;
        $[23] = linkComponent;
        $[24] = onClick;
        $[25] = ref;
        $[26] = testId;
        $[27] = t1;
    } else t1 = $[27];
    return t1;
} : ({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }, ref)=>{
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $f772478f2a45b68d$var$styles.common,
                $f772478f2a45b68d$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                ref: ref,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $w6R6I.cx)($f772478f2a45b68d$var$styles.common, $f772478f2a45b68d$var$styles.pressable),
            ref: ref,
            children: children
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            testId: testId,
            xcss: $f772478f2a45b68d$var$styles.common,
            ref: ref,
            children: children
        });
    } // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref,
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
        children: children
    });
}));
$f772478f2a45b68d$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $f772478f2a45b68d$export$2e2bcd8739ae039 = $f772478f2a45b68d$var$SectionMessageAction;
module.exports["default"] = $f772478f2a45b68d$export$2e2bcd8739ae039;

});

parcelRegister("bz59w", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $2e4957cdb587159c$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};
module.exports["colorMapping"] = $2e4957cdb587159c$export$3351a8d90bcc13aa;

});

parcelRegister("36CpU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $7sJoX = parcelRequire("7sJoX");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $lfoFx = parcelRequire("lfoFx");


var $bz59w = parcelRequire("bz59w");


var $1knih = parcelRequire("1knih");


var $jE4FX = parcelRequire("jE4FX");


var $kMm3u = parcelRequire("kMm3u");


var $ifxxS = parcelRequire("ifxxS");


var $7dnxH = parcelRequire("7dnxH");


var $fc5bD = parcelRequire("fc5bD");


var $8dYJC = parcelRequire("8dYJC");


var $4ea0k = parcelRequire("4ea0k");


var $7tNhr = parcelRequire("7tNhr");


var $hPeTN = parcelRequire("hPeTN");

const $194feaa93758172d$var$styles = {
    baseStyles: "_2mHwu81Y8M _0bjKvDKxmn _2sNsIg7NXe _3hxITi6wH8 _2V7sgONvrM _4c065UFQfX _2Y7lL4qXvR _3SamIH1Y8M _2YLqiK1Y8M _3iDTPbccYA _24h04i2Njc _4ouGXIdnbC _1EqgXl6zFX _0jFU0VbKFA _1mT5xdRAKS _0hPCNLDIqT _0wOv4Q18ZR _0KLXru66of _4bBlWPLRg7",
    noMarginStyles: "_3SamIHPgdg _2YLqiKPgdg",
    removableStyles: "_2mHwu81Y8M",
    beforeStyles: "_00uqCYxTF4 _3xtjKNOiJt _0H9qDFp3yX _3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _1UtDYz93p0",
    beforeStylesSelected: "_1UtDYzrFwf",
    textStyles: "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7 _2O5Vij7dHp _4ouGXIdnbC _1UtDYzy7kJ",
    textEllipsis: "_39HuIbz8Lp",
    textClip: "_39HuIboWuR",
    textStylesSelected: "_1UtDYzjTy9",
    afterStyles: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _1pp6NdIZbP _1mT5xdRAKS",
    afterMotionStyles: "_4ouGXI8HPE",
    trailingMetric: "_0bjKvDcjp5 _2sNsIg7NXe _2Y7lL41Y8M _4c065UdnbC _3iDTPbccYA _24h04i2Njc _4ouGXINHnM _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC _3L9DPXBY1A _0KLXrukWNG _1UtDYzy7kJ",
    trailingMetricEndPadding: "_03SyCPhTjz",
    focusRingStyles: "_4EiLyUXzJH _34b3D2FQfX",
    childFocusRingStyles: "_32BiAhXzJH _3e6OgrFQfX",
    interactiveBaseStyles: "_0wOv4Q7zJH _34GT1P1Y8M _1LCrkc98eZ _2SC11mYbGa _2JMSUR6wH8 _4bE5qGnQyn _4FfyQMnQyn _1gIDyzxTF4 _33YqYbOiJt _01RmT7fKqY _01WXr3ccYA _49zu3GDIqT _0AONSxdnbC _3JFIeFhR7j _28jzjxOiJt _0BhCIUhR7j _21ZxEoxTF4 _0WDgtcOiJt _22lJx0fKqY _2pZq9498eZ _4Bji2LYbGa _2XO6KO6wH8 _0aLvPnOiJt",
    interactiveHoverStyles: "_2QwVYx98eZ _1LyhSa0Rl6 _4x22Mn6wH8 _1eOmH6o126 _1OYUINhR7j _3gzVzLN4oS",
    interactiveMotionStyles: "_23rrnHyKLB _3sFUREiSCN",
    activeMotionStyles: "_4bt5LAnQyn _2WAcuGnQyn"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $194feaa93758172d$var$colorStyles = {
    gray: "_2ssR4FiXlq _3AegxQFEiq _0XbjsdUktF _2TIKKNUktF _1dBX8xG6qS",
    blue: "_2ssR4F432W _3AegxQXb4z _0Xbjsd866Z _2TIKKN866Z _1dBX8xp9dS",
    green: "_2ssR4FWIYU _3AegxQYn9z _0Xbjsd9qYF _2TIKKN9qYF _1dBX8xNUep",
    red: "_2ssR4FDVsW _3AegxQtn31 _0XbjsdjgGB _2TIKKNjgGB _1dBX8xbV9i",
    yellow: "_2ssR4FKuhU _3AegxQx3zE _0XbjsdDIkS _2TIKKNDIkS _1dBX8xLv9B",
    purple: "_2ssR4FrKVc _3AegxQJhIs _0XbjsdYfD7 _2TIKKNYfD7 _1dBX8xWOdT",
    lime: "_2ssR4Fb94u _3AegxQqM33 _0XbjsdqsUt _2TIKKNqsUt _1dBX8xuKDS",
    magenta: "_2ssR4FULTZ _3AegxQOPmJ _0XbjsdSbwp _2TIKKNSbwp _1dBX8xXM4x",
    orange: "_2ssR4FPz9H _3AegxQR8hD _0Xbjsdu4OJ _2TIKKNu4OJ _1dBX8xwJ86",
    teal: "_2ssR4FMMwr _3AegxQdT8X _0XbjsdY3Jz _2TIKKNY3Jz _1dBX8xnfgW"
}; // Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $194feaa93758172d$var$borderIconFilterStyles = {
    root: "_3vBAKHvQ39 _290Qmzs1BN"
}; // Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $194feaa93758172d$var$borderIconInteractiveFilterStyles = {
    root: "_0hPERGvQ39 _2mfSvmBd95 _1IXF3IvQ39 _0K9TL9P3OL"
};
const $194feaa93758172d$var$dropdownStyles = {
    interactive: "_1eOmH6o126 _3gzVzLN4oS",
    selected: "_3vBAKHrzt2 _1UtDYzjTy9 _0KLXruY9q9 _1eOmH6sumd _3gzVzLXsxn",
    content: "_2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC",
    loadingMotion: "_1kOSYt9v2r _3Z9K0wRLuw _0qk6IKjwM9 _1SdfoHYbGa",
    loadingOverlayMotion: "_1gBibygnQY _0nFVCGRLuw _43vdfTjwM9 _39Ohv4YbGa",
    loadingContent: "_1YKVNsdnbC",
    loadingOverlay: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1ZB6UyPgdg _2I62gzPgdg _1OKFqYPgdg _3iC0zdPgdg _1pp6NdYbGa"
}; /**
    * __TagNew__
    *
    * TagNew is the visual uplift implementation of Tag
    */ 
const $194feaa93758172d$var$TagNewComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TagNew(t0, ref) {
    const $ = (0, $bDgLe.c)(40);
    let elemBefore;
    let href;
    let linkComponent;
    let maxWidth;
    let onAfterRemoveAction;
    let onBeforeRemoveAction;
    let onClick;
    let other;
    let removeButtonLabel;
    let swatchBefore;
    let swatchBeforeLabel;
    let swatchBeforeRole;
    let t1;
    let t2;
    let t3;
    let testId;
    let text;
    let trailingMetric;
    if ($[0] !== t0) {
        ({ color: t1, text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: t2, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: t3, onClick: onClick, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other } = t0);
        $[0] = t0;
        $[1] = elemBefore;
        $[2] = href;
        $[3] = linkComponent;
        $[4] = maxWidth;
        $[5] = onAfterRemoveAction;
        $[6] = onBeforeRemoveAction;
        $[7] = onClick;
        $[8] = other;
        $[9] = removeButtonLabel;
        $[10] = swatchBefore;
        $[11] = swatchBeforeLabel;
        $[12] = swatchBeforeRole;
        $[13] = t1;
        $[14] = t2;
        $[15] = t3;
        $[16] = testId;
        $[17] = text;
        $[18] = trailingMetric;
    } else {
        elemBefore = $[1];
        href = $[2];
        linkComponent = $[3];
        maxWidth = $[4];
        onAfterRemoveAction = $[5];
        onBeforeRemoveAction = $[6];
        onClick = $[7];
        other = $[8];
        removeButtonLabel = $[9];
        swatchBefore = $[10];
        swatchBeforeLabel = $[11];
        swatchBeforeRole = $[12];
        t1 = $[13];
        t2 = $[14];
        t3 = $[15];
        testId = $[16];
        text = $[17];
        trailingMetric = $[18];
    }
    const color = t1 === undefined ? "gray" : t1;
    const isRemovable = t2 === undefined ? true : t2;
    const hasMargin = t3 === undefined ? true : t3;
    let t4;
    if ($[19] !== text) {
        t4 = (0, $1knih.getTagText)(text);
        $[19] = text;
        $[20] = t4;
    } else t4 = $[20];
    const normalizedText = t4;
    const isMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-labels");
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $hPeTN.useTagRemoval)(onBeforeRemoveAction);
    let t5;
    if ($[21] !== normalizedText || $[22] !== onAfterRemoveAction) {
        t5 = ()=>{
            onAfterRemoveAction?.(normalizedText);
        };
        $[21] = normalizedText;
        $[22] = onAfterRemoveAction;
        $[23] = t5;
    } else t5 = $[23];
    const onShrinkOutExitComplete = t5;
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $4ea0k.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $8dYJC.useButtonInteraction)();
    let t6;
    if ($[24] !== buttonHandlers || $[25] !== handleRemoveRequest || $[26] !== isRemovable || $[27] !== normalizedText || $[28] !== onKeyPress || $[29] !== removeButtonLabel || $[30] !== removingTag || $[31] !== showingTag || $[32] !== testId) {
        t6 = {
            isRemovable: isRemovable,
            tagText: normalizedText,
            removeButtonLabel: removeButtonLabel,
            testId: testId,
            handleRemoveRequest: handleRemoveRequest,
            removingTag: removingTag,
            showingTag: showingTag,
            onKeyPress: onKeyPress,
            buttonHandlers: buttonHandlers
        };
        $[24] = buttonHandlers;
        $[25] = handleRemoveRequest;
        $[26] = isRemovable;
        $[27] = normalizedText;
        $[28] = onKeyPress;
        $[29] = removeButtonLabel;
        $[30] = removingTag;
        $[31] = showingTag;
        $[32] = testId;
        $[33] = t6;
    } else t6 = $[33];
    const removeButton = (0, $7tNhr.useRemoveButton)(t6);
    const renderTagContent = (tagRef, t7, t8, t9)=>{
        const isEntering = t7 === undefined ? false : t7;
        const isExiting = t8 === undefined ? false : t8;
        const hasEllipsis = t9 === undefined ? null : t9;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            ...other,
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $hekY6.default)([
                $194feaa93758172d$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $194feaa93758172d$var$styles.noMarginStyles,
                $194feaa93758172d$var$colorStyles[color],
                $194feaa93758172d$var$borderIconFilterStyles.root,
                isLink && $194feaa93758172d$var$styles.interactiveBaseStyles,
                isLink && $194feaa93758172d$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $194feaa93758172d$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $194feaa93758172d$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $194feaa93758172d$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $194feaa93758172d$var$styles.interactiveHoverStyles,
                isRemovable && $194feaa93758172d$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $194feaa93758172d$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== "" && $194feaa93758172d$var$styles.trailingMetricEndPadding
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $jE4FX.LinkWrapper), {
                    isLink: isLink,
                    href: href,
                    LinkComponent: LinkComponent,
                    testId: testId,
                    linkHandlers: linkHandlers,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7dnxH.default), {
                            colorKey: color,
                            swatchBefore: swatchBefore,
                            swatchBeforeLabel: swatchBeforeLabel,
                            swatchBeforeRole: swatchBeforeRole
                        }),
                        elemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $194feaa93758172d$var$styles.beforeStyles
                            ]),
                            children: elemBefore
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-tag-text": true,
                            className: (0, $hekY6.default)([
                                $194feaa93758172d$var$styles.textStyles,
                                hasEllipsis === false ? $194feaa93758172d$var$styles.textClip : $194feaa93758172d$var$styles.textEllipsis
                            ]),
                            children: normalizedText
                        }),
                        trailingMetric != null && trailingMetric !== "" && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-testid": testId && `${testId}--metric`,
                            className: (0, $hekY6.default)([
                                $194feaa93758172d$var$styles.trailingMetric
                            ]),
                            children: trailingMetric
                        })
                    ]
                }),
                removeButton && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $194feaa93758172d$var$styles.afterStyles,
                        isMotionEnabled && $194feaa93758172d$var$styles.afterMotionStyles
                    ]),
                    children: !isExiting && removeButton
                })
            ]
        });
    };
    if (isMotionEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc5bD.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status,
        children: (t10)=>{
            const { hasEllipsis: hasEllipsis_0, isEntering: isEntering_0, isExiting: isExiting_0, ref: motionRef } = t10;
            return renderTagContent(motionRef, isEntering_0, isExiting_0, hasEllipsis_0);
        }
    });
    const T0 = (0, $kMm3u.RemovableWrapper);
    const t10 = isRemovable ? onShrinkOutExitComplete : undefined;
    const t11 = renderTagContent(ref);
    let t12;
    if ($[34] !== T0 || $[35] !== isRemovable || $[36] !== status || $[37] !== t10 || $[38] !== t11) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)(T0, {
            isRemovable: isRemovable,
            status: status,
            onShrinkOutExitComplete: t10,
            children: t11
        });
        $[34] = T0;
        $[35] = isRemovable;
        $[36] = status;
        $[37] = t10;
        $[38] = t11;
        $[39] = t12;
    } else t12 = $[39];
    return t12;
} : function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $1knih.getTagText)(text);
    const isMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-labels');
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $hPeTN.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $cozmU.useCallback)(()=>{
        onAfterRemoveAction?.(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $4ea0k.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $8dYJC.useButtonInteraction)();
    const removeButton = (0, $7tNhr.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const renderTagContent = (tagRef, isEntering = false, isExiting = false, hasEllipsis = null)=>/*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            ...other,
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $hekY6.default)([
                $194feaa93758172d$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $194feaa93758172d$var$styles.noMarginStyles,
                $194feaa93758172d$var$colorStyles[color],
                $194feaa93758172d$var$borderIconFilterStyles.root,
                isLink && $194feaa93758172d$var$styles.interactiveBaseStyles,
                isLink && $194feaa93758172d$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $194feaa93758172d$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $194feaa93758172d$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $194feaa93758172d$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $194feaa93758172d$var$styles.interactiveHoverStyles,
                isRemovable && $194feaa93758172d$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $194feaa93758172d$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $194feaa93758172d$var$styles.trailingMetricEndPadding
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $jE4FX.LinkWrapper), {
                    isLink: isLink,
                    href: href,
                    LinkComponent: LinkComponent,
                    testId: testId,
                    linkHandlers: linkHandlers,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7dnxH.default), {
                            colorKey: color,
                            swatchBefore: swatchBefore,
                            swatchBeforeLabel: swatchBeforeLabel,
                            swatchBeforeRole: swatchBeforeRole
                        }),
                        elemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $194feaa93758172d$var$styles.beforeStyles
                            ]),
                            children: elemBefore
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-tag-text": true,
                            className: (0, $hekY6.default)([
                                $194feaa93758172d$var$styles.textStyles,
                                hasEllipsis === false ? $194feaa93758172d$var$styles.textClip : $194feaa93758172d$var$styles.textEllipsis
                            ]),
                            children: normalizedText
                        }),
                        trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-testid": testId && `${testId}--metric`,
                            className: (0, $hekY6.default)([
                                $194feaa93758172d$var$styles.trailingMetric
                            ]),
                            children: trailingMetric
                        })
                    ]
                }),
                removeButton && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $194feaa93758172d$var$styles.afterStyles,
                        isMotionEnabled && $194feaa93758172d$var$styles.afterMotionStyles
                    ]),
                    children: !isExiting && removeButton
                })
            ]
        });
    if (isMotionEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc5bD.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status,
        children: ({ hasEllipsis: hasEllipsis_0, isEntering: isEntering_0, isExiting: isExiting_0, ref: motionRef })=>renderTagContent(motionRef, isEntering_0, isExiting_0, hasEllipsis_0)
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kMm3u.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: renderTagContent(ref)
    });
}); // Put the tag dropdown trigger in this file to reuse the styles
const $194feaa93758172d$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TagDropdownTrigger(t0, ref) {
    const $ = (0, $bDgLe.c)(60);
    let elemBefore;
    let maxWidth;
    let onClick;
    let other;
    let swatchBefore;
    let swatchBeforeLabel;
    let swatchBeforeRole;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let testId;
    let text;
    let trailingMetric;
    if ($[0] !== t0) {
        const { color: t6, text: t7, elemBefore: t8, testId: t9, maxWidth: t10, hasMargin: t11, onClick: t12, isSelected: t13, isLoading: t14, analyticsContext: _analyticsContext, hasChevron: t15, swatchBefore: t16, swatchBeforeLabel: t17, swatchBeforeRole: t18, trailingMetric: t19, ...t20 } = t0;
        t1 = t6;
        text = t7;
        elemBefore = t8;
        testId = t9;
        maxWidth = t10;
        t2 = t11;
        onClick = t12;
        t3 = t13;
        t4 = t14;
        t5 = t15;
        swatchBefore = t16;
        swatchBeforeLabel = t17;
        swatchBeforeRole = t18;
        trailingMetric = t19;
        other = t20;
        $[0] = t0;
        $[1] = elemBefore;
        $[2] = maxWidth;
        $[3] = onClick;
        $[4] = other;
        $[5] = swatchBefore;
        $[6] = swatchBeforeLabel;
        $[7] = swatchBeforeRole;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = testId;
        $[14] = text;
        $[15] = trailingMetric;
    } else {
        elemBefore = $[1];
        maxWidth = $[2];
        onClick = $[3];
        other = $[4];
        swatchBefore = $[5];
        swatchBeforeLabel = $[6];
        swatchBeforeRole = $[7];
        t1 = $[8];
        t2 = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        testId = $[13];
        text = $[14];
        trailingMetric = $[15];
    }
    const color = t1 === undefined ? "gray" : t1;
    const hasMargin = t2 === undefined ? true : t2;
    const isSelected = t3 === undefined ? false : t3;
    const isLoading = t4 === undefined ? false : t4;
    const hasChevron = t5 === undefined ? true : t5;
    const resolvedColor = (0, $bz59w.colorMapping)[color] || "gray";
    let t6;
    if ($[16] !== elemBefore || $[17] !== hasChevron || $[18] !== hasMargin || $[19] !== isLoading || $[20] !== isSelected || $[21] !== maxWidth || $[22] !== onClick || $[23] !== other || $[24] !== ref || $[25] !== resolvedColor || $[26] !== swatchBefore || $[27] !== swatchBeforeLabel || $[28] !== swatchBeforeRole || $[29] !== testId || $[30] !== text || $[31] !== trailingMetric) {
        const isMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-labels");
        const t7 = (0, $k12R1.cx)($194feaa93758172d$var$styles.baseStyles, !hasMargin && $194feaa93758172d$var$styles.noMarginStyles, $194feaa93758172d$var$colorStyles[resolvedColor], $194feaa93758172d$var$borderIconFilterStyles.root, $194feaa93758172d$var$dropdownStyles.interactive, $194feaa93758172d$var$styles.focusRingStyles, $194feaa93758172d$var$borderIconInteractiveFilterStyles.root, isSelected && $194feaa93758172d$var$dropdownStyles.selected, isMotionEnabled && $194feaa93758172d$var$styles.interactiveMotionStyles, !hasChevron && trailingMetric != null && trailingMetric !== "" && $194feaa93758172d$var$styles.trailingMetricEndPadding);
        const t8 = isSelected ? "var(--ds-border-selected, #1868DB)" : undefined;
        const t9 = isLoading ? "progress" : "pointer";
        const t10 = maxWidth !== undefined ? maxWidth : undefined;
        let t11;
        if ($[33] !== t10 || $[34] !== t8 || $[35] !== t9) {
            t11 = {
                borderColor: t8,
                cursor: t9,
                maxWidth: t10
            };
            $[33] = t10;
            $[34] = t8;
            $[35] = t9;
            $[36] = t11;
        } else t11 = $[36];
        let t12;
        if ($[37] !== isLoading) {
            t12 = isLoading && {
                "aria-busy": true,
                "aria-disabled": true,
                isDisabled: true
            };
            $[37] = isLoading;
            $[38] = t12;
        } else t12 = $[38];
        const t13 = (0, $hekY6.default)([
            $194feaa93758172d$var$dropdownStyles.content,
            isMotionEnabled && $194feaa93758172d$var$dropdownStyles.loadingMotion,
            isLoading && $194feaa93758172d$var$dropdownStyles.loadingContent
        ]);
        let t14;
        if ($[39] !== resolvedColor || $[40] !== swatchBefore || $[41] !== swatchBeforeLabel || $[42] !== swatchBeforeRole) {
            t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7dnxH.default), {
                colorKey: resolvedColor,
                swatchBefore: swatchBefore,
                swatchBeforeLabel: swatchBeforeLabel,
                swatchBeforeRole: swatchBeforeRole
            });
            $[39] = resolvedColor;
            $[40] = swatchBefore;
            $[41] = swatchBeforeLabel;
            $[42] = swatchBeforeRole;
            $[43] = t14;
        } else t14 = $[43];
        let t15;
        if ($[44] !== elemBefore || $[45] !== isSelected) {
            t15 = elemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $194feaa93758172d$var$styles.beforeStyles,
                    isSelected && $194feaa93758172d$var$styles.beforeStylesSelected
                ]),
                children: elemBefore
            });
            $[44] = elemBefore;
            $[45] = isSelected;
            $[46] = t15;
        } else t15 = $[46];
        const t16 = isSelected && $194feaa93758172d$var$styles.textStylesSelected;
        let t17;
        if ($[47] !== t16) {
            t17 = (0, $hekY6.default)([
                $194feaa93758172d$var$styles.textStyles,
                $194feaa93758172d$var$styles.textEllipsis,
                t16
            ]);
            $[47] = t16;
            $[48] = t17;
        } else t17 = $[48];
        let t18;
        if ($[49] !== text) {
            t18 = (0, $1knih.getTagText)(text);
            $[49] = text;
            $[50] = t18;
        } else t18 = $[50];
        let t19;
        if ($[51] !== t17 || $[52] !== t18) {
            t19 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-tag-text": true,
                className: t17,
                children: t18
            });
            $[51] = t17;
            $[52] = t18;
            $[53] = t19;
        } else t19 = $[53];
        let t20;
        if ($[54] !== testId || $[55] !== trailingMetric) {
            t20 = trailingMetric != null && trailingMetric !== "" && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-testid": testId && `${testId}--metric`,
                className: (0, $hekY6.default)([
                    $194feaa93758172d$var$styles.trailingMetric
                ]),
                children: trailingMetric
            });
            $[54] = testId;
            $[55] = trailingMetric;
            $[56] = t20;
        } else t20 = $[56];
        let t21;
        if ($[57] !== hasChevron || $[58] !== testId) {
            t21 = hasChevron && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small",
                color: "currentColor",
                testId: testId && `${testId}--chevron`
            });
            $[57] = hasChevron;
            $[58] = testId;
            $[59] = t21;
        } else t21 = $[59];
        t6 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
            ref: ref,
            xcss: t7,
            onClick: isLoading ? undefined : onClick,
            style: t11,
            ...t12,
            testId: testId,
            ...other,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: t13,
                    children: [
                        t14,
                        t15,
                        t19,
                        t20,
                        t21
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $194feaa93758172d$var$dropdownStyles.loadingOverlay,
                        isMotionEnabled && $194feaa93758172d$var$dropdownStyles.loadingOverlayMotion
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: "xsmall",
                        label: ", Loading",
                        testId: testId ? `${testId}--loading-spinner` : undefined
                    })
                })
            ]
        });
        $[16] = elemBefore;
        $[17] = hasChevron;
        $[18] = hasMargin;
        $[19] = isLoading;
        $[20] = isSelected;
        $[21] = maxWidth;
        $[22] = onClick;
        $[23] = other;
        $[24] = ref;
        $[25] = resolvedColor;
        $[26] = swatchBefore;
        $[27] = swatchBeforeLabel;
        $[28] = swatchBeforeRole;
        $[29] = testId;
        $[30] = text;
        $[31] = trailingMetric;
        $[32] = t6;
    } else t6 = $[32];
    return t6;
} : function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $bz59w.colorMapping)[color] || 'gray';
    const isMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
        ref: ref,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($194feaa93758172d$var$styles.baseStyles, !hasMargin && $194feaa93758172d$var$styles.noMarginStyles, $194feaa93758172d$var$colorStyles[resolvedColor], $194feaa93758172d$var$borderIconFilterStyles.root, $194feaa93758172d$var$dropdownStyles.interactive, $194feaa93758172d$var$styles.focusRingStyles, $194feaa93758172d$var$borderIconInteractiveFilterStyles.root, isSelected && $194feaa93758172d$var$dropdownStyles.selected, isMotionEnabled && $194feaa93758172d$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $194feaa93758172d$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                className: (0, $hekY6.default)([
                    $194feaa93758172d$var$dropdownStyles.content,
                    isMotionEnabled && $194feaa93758172d$var$dropdownStyles.loadingMotion,
                    isLoading && $194feaa93758172d$var$dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7dnxH.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore,
                        swatchBeforeLabel: swatchBeforeLabel,
                        swatchBeforeRole: swatchBeforeRole
                    }),
                    elemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        className: (0, $hekY6.default)([
                            $194feaa93758172d$var$styles.beforeStyles,
                            isSelected && $194feaa93758172d$var$styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $hekY6.default)([
                            $194feaa93758172d$var$styles.textStyles,
                            $194feaa93758172d$var$styles.textEllipsis,
                            isSelected && $194feaa93758172d$var$styles.textStylesSelected
                        ]),
                        children: (0, $1knih.getTagText)(text)
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $hekY6.default)([
                            $194feaa93758172d$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    }),
                    hasChevron && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && `${testId}--chevron`
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $194feaa93758172d$var$dropdownStyles.loadingOverlay,
                    isMotionEnabled && $194feaa93758172d$var$dropdownStyles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
}); /**
     * __Tag new__
     */ 
const $194feaa93758172d$var$TagNew = (0, $ifxxS.markAsTagMotionCapable)(/*#__PURE__*/ (0, $cozmU.memo)($194feaa93758172d$var$TagNewComponent));
var $194feaa93758172d$export$2e2bcd8739ae039 = $194feaa93758172d$var$TagNew;
module.exports["default"] = $194feaa93758172d$export$2e2bcd8739ae039;

});

parcelRegister("ifxxS", function(module, exports) {
const $bcc0889477ef4d8d$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $bcc0889477ef4d8d$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $bcc0889477ef4d8d$var$tagMotionCapability, {
        value: true
    });
    return component;
}
module.exports["markAsTagMotionCapable"] = $bcc0889477ef4d8d$export$88b132e52a65ec37;

});

parcelRegister("EOob6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $54133816ae4afde3$var$borderColors = {
    standard: "_3vBAKHT3oA",
    blue: "_3vBAKHTOnn",
    red: "_3vBAKHbxQq",
    yellow: "_3vBAKHehXs",
    green: "_3vBAKHz1yx",
    teal: "_3vBAKHUSsG",
    purple: "_3vBAKHEWfT",
    lime: "_3vBAKHc0Gz",
    magenta: "_3vBAKHYmXL",
    orange: "_3vBAKHmPNR",
    grey: "_3vBAKHT3oA",
    standardLink: "_3vBAKHT3oA",
    blueLight: "_3vBAKHTOnn",
    redLight: "_3vBAKHbxQq",
    yellowLight: "_3vBAKHehXs",
    greenLight: "_3vBAKHz1yx",
    tealLight: "_3vBAKHUSsG",
    purpleLight: "_3vBAKHEWfT",
    limeLight: "_3vBAKHc0Gz",
    magentaLight: "_3vBAKHYmXL",
    orangeLight: "_3vBAKHmPNR",
    greyLight: "_3vBAKHT3oA"
};
const $54133816ae4afde3$var$baseStyles = null;
const $54133816ae4afde3$var$interactiveStyles = null;
const $54133816ae4afde3$var$focusRingStyles = null;
const $54133816ae4afde3$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function BaseTag(t0, ref) {
    const $ = (0, $bDgLe.c)(26);
    let after;
    let before;
    let className;
    let contentElement;
    let href;
    let other;
    let style;
    let t1;
    let testId;
    if ($[0] !== t0) {
        ({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: t1, href: href, className: className, ...other } = t0);
        $[0] = t0;
        $[1] = after;
        $[2] = before;
        $[3] = className;
        $[4] = contentElement;
        $[5] = href;
        $[6] = other;
        $[7] = style;
        $[8] = t1;
        $[9] = testId;
    } else {
        after = $[1];
        before = $[2];
        className = $[3];
        contentElement = $[4];
        href = $[5];
        other = $[6];
        style = $[7];
        t1 = $[8];
        testId = $[9];
    }
    let color = t1 === undefined ? "standard" : t1;
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === "gray") color = "grey";
    let t2;
    if ($[10] !== style) {
        t2 = {
            ...style
        };
        $[10] = style;
        $[11] = t2;
    } else t2 = $[11];
    const t3 = t2;
    const t4 = isInteractive && "_3iYkPuXzJH _0ux1jMFQfX";
    const t5 = isLink && "_1eOmH6o126 _3gzVzLN4oS";
    const t6 = $54133816ae4afde3$var$borderColors[color];
    let t7;
    if ($[12] !== className || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t7 = (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _3SamIH1Y8M _2YLqiK1Y8M _2Y7lL41Y8M _3iDTPbccYA _24h04i2Njc _4ouGXIdnbC _0jFU0VbKFA _1mT5xdRAKS _0hPCNLDIqT _0KLXru66of _1UtDYzy7kJ _0wOv4Q18ZR",
            t4,
            t5,
            t6,
            className
        ]);
        $[12] = className;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== after || $[18] !== before || $[19] !== contentElement || $[20] !== other || $[21] !== ref || $[22] !== t3 || $[23] !== t7 || $[24] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            ...other,
            ref: ref,
            style: t3,
            className: t7,
            "data-testid": testId,
            children: [
                before,
                contentElement,
                after
            ]
        });
        $[17] = after;
        $[18] = before;
        $[19] = contentElement;
        $[20] = other;
        $[21] = ref;
        $[22] = t3;
        $[23] = t7;
        $[24] = testId;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _3SamIH1Y8M _2YLqiK1Y8M _2Y7lL41Y8M _3iDTPbccYA _24h04i2Njc _4ouGXIdnbC _0jFU0VbKFA _1mT5xdRAKS _0hPCNLDIqT _0KLXru66of _1UtDYzy7kJ _0wOv4Q18ZR",
            isInteractive && "_3iYkPuXzJH _0ux1jMFQfX",
            isLink && "_1eOmH6o126 _3gzVzLN4oS",
            $54133816ae4afde3$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $54133816ae4afde3$export$2e2bcd8739ae039 = $54133816ae4afde3$var$BaseTag;
module.exports["default"] = $54133816ae4afde3$export$2e2bcd8739ae039;

});

parcelRegister("8D4k8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $00c53f0910650c8e$var$beforeElementStyles = null;
const $00c53f0910650c8e$var$Before = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { elemBefore: elemBefore } = t0;
    let t1;
    if ($[0] !== elemBefore) {
        t1 = elemBefore ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0jFU0VQAma _0hPCNLDIqT _37wbyuDIqT _2I62gzPgdg"
            ]),
            children: elemBefore
        }) : null;
        $[0] = elemBefore;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VQAma _0hPCNLDIqT _37wbyuDIqT _2I62gzPgdg"
        ]),
        children: elemBefore
    }) : null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $00c53f0910650c8e$export$2e2bcd8739ae039 = $00c53f0910650c8e$var$Before;
module.exports["default"] = $00c53f0910650c8e$export$2e2bcd8739ae039;

});

parcelRegister("2IHCL", function(module, exports) {
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $5d73b411e10de774$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $5d73b411e10de774$export$4d9e331cafeacb9d(color) {
    return $5d73b411e10de774$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}
module.exports["getLozengeAppearance"] = $5d73b411e10de774$export$4d9e331cafeacb9d;

});

parcelRegister("lzska", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1knih = parcelRequire("1knih");

const $44d2e712944d2b91$var$baseStyles = null;
const $44d2e712944d2b91$var$linkStyles = null;
const $44d2e712944d2b91$var$hasAfterStyles = null;
const $44d2e712944d2b91$var$Content = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { isRemovable: t1, text: t2, color: t3, href: href, linkComponent: linkComponent, testId: testId } = t0;
    const isRemovable = t1 === undefined ? true : t1;
    const text = t2 === undefined ? "" : t2;
    const color = t3 === undefined ? "standard" : t3;
    const Link = linkComponent ?? "a";
    let t4;
    if ($[0] !== text) {
        t4 = (0, $1knih.getTagText)(text);
        $[0] = text;
        $[1] = t4;
    } else t4 = $[1];
    const normalizedText = t4;
    if (href) {
        const t5 = testId ? `${testId}--link` : undefined;
        const t6 = isRemovable && "_1EqgXloaux";
        let t7;
        if ($[2] !== t6) {
            t7 = (0, $hekY6.default)([
                "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1EqgXl6zFX _39HuIbz8Lp _1ANEUSLRg7",
                "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzy7kJ _1pp6NdIZbP _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMy7kJ _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
                t6
            ]);
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== Link || $[5] !== color || $[6] !== href || $[7] !== normalizedText || $[8] !== t5 || $[9] !== t7) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)(Link, {
                href: href,
                "data-color": color,
                "data-testid": t5,
                className: t7,
                children: normalizedText
            });
            $[4] = Link;
            $[5] = color;
            $[6] = href;
            $[7] = normalizedText;
            $[8] = t5;
            $[9] = t7;
            $[10] = t8;
        } else t8 = $[10];
        return t8;
    } else {
        const t5 = isRemovable && "_1EqgXloaux";
        let t6;
        if ($[11] !== t5) {
            t6 = (0, $hekY6.default)([
                "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1EqgXl6zFX _39HuIbz8Lp _1ANEUSLRg7",
                t5
            ]);
            $[11] = t5;
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== normalizedText || $[14] !== t6) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: t6,
                children: normalizedText
            });
            $[13] = normalizedText;
            $[14] = t6;
            $[15] = t7;
        } else t7 = $[15];
        return t7;
    }
} : ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    const normalizedText = (0, $1knih.getTagText)(text);
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1EqgXl6zFX _39HuIbz8Lp _1ANEUSLRg7",
            "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzy7kJ _1pp6NdIZbP _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMy7kJ _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
            isRemovable && "_1EqgXloaux"
        ]),
        children: normalizedText
    });
    else return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1EqgXl6zFX _39HuIbz8Lp _1ANEUSLRg7",
            isRemovable && "_1EqgXloaux"
        ]),
        children: normalizedText
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $44d2e712944d2b91$export$2e2bcd8739ae039 = $44d2e712944d2b91$var$Content;
module.exports["default"] = $44d2e712944d2b91$export$2e2bcd8739ae039;

});

parcelRegister("jALA9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $78t8C = parcelRequire("78t8C");


var $w6R6I = parcelRequire("w6R6I");


var $7sJoX = parcelRequire("7sJoX");


var $4Uejl = parcelRequire("4Uejl");


var $iDrrr = parcelRequire("iDrrr");


var $kh0hi = parcelRequire("kh0hi");


var $lfoFx = parcelRequire("lfoFx");


var $iNqPL = parcelRequire("iNqPL");


var $gSFZN = parcelRequire("gSFZN");


var $gnQSb = parcelRequire("gnQSb");

const $44fbebf285dcdbcf$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $44fbebf285dcdbcf$var$styles = {
    container: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _0jFU0VbKFA _46hvQmFQfX _0xmtkoFQfX _0LQT5E1Y8M _03SyCP1Y8M",
    motionContainer: "_1kOSYt0ssM _3Z9K0wLrT7 _0qk6IKxt7V",
    containerSpacious: "_0bjKvDKTcp _4kiQYAZ49V _46hvQm1Y8M _0xmtko1Y8M _0LQT5E8HPE _03SyCP8HPE",
    containerBadgePadding: "_03SyCPhTjz",
    text: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7",
    textEllipsis: "_39HuIbz8Lp",
    textClip: "_39HuIboWuR",
    textSpacious: "_2sNsIgmnOE _1kk5Tkf7mX",
    textSelected: "_1UtDYzjTy9",
    loadingOverlay: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1ZB6UyPgdg _2I62gzPgdg _1OKFqYPgdg _3iC0zdPgdg _1pp6NdYbGa",
    loadingOverlayMotion: "_1gBibygnQY _0nFVCGRLuw _43vdfTjwM9",
    metricBadgeWrapper: "_3iDTPbQ4SZ",
    'semantic.success': "_0g0wFM6qxx _0KLXruQuCm _1UtDYzM9Wa",
    'semantic.warning': "_0g0wFM4ATQ _0KLXru2bwY _1UtDYzVRW9",
    'semantic.danger': "_0g0wFMoUoy _0KLXruJXmd _1UtDYzOZ2O",
    'semantic.information': "_0g0wFMzKYA _0KLXru9V7L _1UtDYzdx2f",
    'semantic.neutral': "_0g0wFM9r67 _0KLXruDMqu _1UtDYzy7kJ",
    'semantic.discovery': "_0g0wFMG92r _0KLXruZB9y _1UtDYzAGgF",
    'accent.red': "_0g0wFMDVsW _0KLXrubV9i _1UtDYziNu3",
    'accent.orange': "_0g0wFMPz9H _0KLXruwJ86 _1UtDYzH9Ub",
    'accent.yellow': "_0g0wFMKuhU _0KLXruLv9B _1UtDYzD7aB",
    'accent.lime': "_0g0wFMb94u _0KLXruuKDS _1UtDYzfXoY",
    'accent.green': "_0g0wFMWIYU _0KLXruNUep _1UtDYzgGm3",
    'accent.teal': "_0g0wFMMMwr _0KLXrunfgW _1UtDYz2SoF",
    'accent.blue': "_0g0wFM432W _0KLXrup9dS _1UtDYz802h",
    'accent.purple': "_0g0wFMrKVc _0KLXruWOdT _1UtDYzXCFT",
    'accent.magenta': "_0g0wFMULTZ _0KLXruXM4x _1UtDYzcMOQ",
    'accent.gray': "_0g0wFM9r67 _0KLXrumhAQ _1UtDYzyXux",
    'interactive.semantic.success': "_1eOmH6IvPJ _3gzVzLWiFb",
    'interactive.semantic.warning': "_1eOmH6d32T _3gzVzLlPVC",
    'interactive.semantic.danger': "_1eOmH6NsSy _3gzVzLdWib",
    'interactive.semantic.information': "_1eOmH60REk _3gzVzLZLqO",
    'interactive.semantic.neutral': "_1eOmH6KcZT _3gzVzLnpTK",
    'interactive.semantic.discovery': "_1eOmH6Y0Bq _3gzVzLXyqi",
    'interactive.accent.red': "_1eOmH6FOVf _3gzVzLFnU8",
    'interactive.accent.orange': "_1eOmH6Eo5I _3gzVzL78bI",
    'interactive.accent.yellow': "_1eOmH6JMtC _3gzVzLVvUp",
    'interactive.accent.lime': "_1eOmH6uIDk _3gzVzLyTNr",
    'interactive.accent.green': "_1eOmH6SZVv _3gzVzLratX",
    'interactive.accent.teal': "_1eOmH6A8mq _3gzVzLjHQE",
    'interactive.accent.blue': "_1eOmH6RRyT _3gzVzLeeqx",
    'interactive.accent.purple': "_1eOmH6jgGS _3gzVzLWgRz",
    'interactive.accent.magenta': "_1eOmH6kPhQ _3gzVzLGjVz",
    'interactive.accent.gray': "_1eOmH6Bee8 _3gzVzLysrI",
    iconBorderFilter: "_3vBAKHaWtd",
    content: "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT",
    maxWidth: "_1EqgXlN91d",
    contentSpacious: "_2mHwu8gVvo",
    loadingContent: "_1YKVNsdnbC",
    loadingMotion: "_1kOSYt9v2r _3Z9K0wRLuw _0qk6IKjwM9",
    containerBadgePressed: "_363D0BsIOW _2S1O8ssIOW",
    containerBadgeNeutralAppearance: "_3q52gvqpuF _363D0BqpuF _2S1O8sqpuF"
};
const $44fbebf285dcdbcf$var$interactiveMotionStyles = {
    motion: "_23rrnHyKLB _3sFUREiSCN"
}; /**
    * __New Lozenge__
    *
    * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
    * This is the updated version with the new North Star visual language.
    */ 
const $44fbebf285dcdbcf$var$LozengeBase = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(96);
    const { children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: t1, spacing: t2, isSelected: isSelected, isLoading: t3, onClick: onClick, style: style, analyticsContext: analyticsContext, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHaspopup, "aria-label": ariaLabel } = t0;
    const maxWidth = t1 === undefined ? 200 : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const isLoading = t3 === undefined ? false : t3;
    const [resizing, setResizing] = (0, $cozmU.useState)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setResizing(false);
        $[0] = t4;
    } else t4 = $[0];
    const onFinishMotion = t4;
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            dimension: "width",
            duration: "var(--ds-duration-medium, 200ms)",
            easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
            onFinishMotion: onFinishMotion
        };
        $[1] = t5;
    } else t5 = $[1];
    const resizingWidth = (0, $4Uejl.useResizing)(t5);
    const isInitialRender = (0, $cozmU.useRef)(true);
    const isInteractive = typeof onClick === "function";
    let colorStyleKey;
    let interactiveStyleKey;
    let maxWidthIsPc;
    let maxWidthValue;
    let resolvedColor;
    let resolvedTrailingMetricAppearance;
    let t6;
    if ($[2] !== appearance || $[3] !== maxWidth || $[4] !== trailingMetricAppearance) {
        resolvedColor = (0, $gnQSb.resolveLozengeColor)(appearance) || "neutral";
        const { category: category, key: key } = (0, $iNqPL.getThemeStyles)(resolvedColor);
        colorStyleKey = `${category}.${key}`;
        interactiveStyleKey = `interactive.${category}.${key}`;
        maxWidthValue = typeof maxWidth === "string" ? maxWidth : `${maxWidth}px`;
        let t7;
        if ($[12] !== maxWidth) {
            t7 = typeof maxWidth === "string" && maxWidth.endsWith("%");
            $[12] = maxWidth;
            $[13] = t7;
        } else t7 = $[13];
        maxWidthIsPc = t7;
        resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === "inverse" ? "inverse" : (0, $gnQSb.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
        bb0: {
            if (resolvedTrailingMetricAppearance === "inverse") {
                t6 = "inverse";
                break bb0;
            }
            if (resolvedTrailingMetricAppearance == null) {
                t6 = "neutral";
                break bb0;
            }
            if (resolvedTrailingMetricAppearance.startsWith("accent-")) {
                t6 = "neutral";
                break bb0;
            }
            switch(resolvedTrailingMetricAppearance){
                case "success":
                    t6 = "successBold";
                    break bb0;
                case "warning":
                    t6 = "warningBold";
                    break bb0;
                case "danger":
                    t6 = "dangerBold";
                    break bb0;
                case "information":
                    t6 = "informationBold";
                    break bb0;
                case "discovery":
                    t6 = "discoveryBold";
                    break bb0;
                case "neutral":
                default:
                    t6 = "neutral";
            }
        }
        $[2] = appearance;
        $[3] = maxWidth;
        $[4] = trailingMetricAppearance;
        $[5] = colorStyleKey;
        $[6] = interactiveStyleKey;
        $[7] = maxWidthIsPc;
        $[8] = maxWidthValue;
        $[9] = resolvedColor;
        $[10] = resolvedTrailingMetricAppearance;
        $[11] = t6;
    } else {
        colorStyleKey = $[5];
        interactiveStyleKey = $[6];
        maxWidthIsPc = $[7];
        maxWidthValue = $[8];
        resolvedColor = $[9];
        resolvedTrailingMetricAppearance = $[10];
        t6 = $[11];
    }
    const metricBadgeAppearance = t6;
    const t7 = style?.backgroundColor;
    const t8 = maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`;
    let t9;
    if ($[14] !== t7 || $[15] !== t8) {
        t9 = {
            backgroundColor: t7,
            maxWidth: t8
        };
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    const commonStyleOverrides = t9;
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== "";
    const childrenKey = typeof children === "string" ? children : undefined;
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            if (isInitialRender.current) {
                isInitialRender.current = false;
                return;
            }
            setResizing(true);
        };
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== childrenKey) {
        t11 = [
            childrenKey
        ];
        $[18] = childrenKey;
        $[19] = t11;
    } else t11 = $[19];
    (0, $cozmU.useLayoutEffect)(t10, t11);
    let innerContent;
    let t12;
    if ($[20] !== analyticsContext || $[21] !== ariaControls || $[22] !== ariaExpanded || $[23] !== ariaHaspopup || $[24] !== ariaLabel || $[25] !== children || $[26] !== colorStyleKey || $[27] !== commonStyleOverrides || $[28] !== hasTrailingMetric || $[29] !== iconBefore || $[30] !== interactionName || $[31] !== interactiveStyleKey || $[32] !== isInteractive || $[33] !== isLoading || $[34] !== isSelected || $[35] !== maxWidth || $[36] !== maxWidthIsPc || $[37] !== maxWidthValue || $[38] !== metricBadgeAppearance || $[39] !== onClick || $[40] !== ref || $[41] !== resizing || $[42] !== resizingWidth || $[43] !== resolvedColor || $[44] !== resolvedTrailingMetricAppearance || $[45] !== spacing || $[46] !== style?.color || $[47] !== testId || $[48] !== trailingMetric) {
        t12 = Symbol.for("react.early_return_sentinel");
        bb1: {
            const enableMotionFG = (0, $iDrrr.fg)("platform-dst-motion-uplift");
            const enableButtonMotionFG = (0, $iDrrr.fg)("platform-dst-motion-uplift-button");
            const t13 = (0, $hekY6.default)([
                $44fbebf285dcdbcf$var$styles.content,
                spacing === "spacious" && $44fbebf285dcdbcf$var$styles.contentSpacious,
                isInteractive && enableButtonMotionFG && $44fbebf285dcdbcf$var$styles.loadingMotion,
                isLoading && $44fbebf285dcdbcf$var$styles.loadingContent,
                $44fbebf285dcdbcf$var$styles.maxWidth
            ]);
            let t14;
            if ($[51] !== iconBefore || $[52] !== resolvedColor || $[53] !== spacing || $[54] !== testId) {
                t14 = iconBefore && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gSFZN.default), {
                    size: spacing === "spacious" ? "medium" : "small",
                    icon: iconBefore,
                    color: resolvedColor,
                    testId: testId && `${testId}--icon`
                });
                $[51] = iconBefore;
                $[52] = resolvedColor;
                $[53] = spacing;
                $[54] = testId;
                $[55] = t14;
            } else t14 = $[55];
            const t15 = maxWidthIsPc ? "100%" : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`;
            const t16 = style?.color;
            let t17;
            if ($[56] !== t15 || $[57] !== t16) {
                t17 = {
                    maxWidth: t15,
                    color: t16
                };
                $[56] = t15;
                $[57] = t16;
                $[58] = t17;
            } else t17 = $[58];
            const t18 = testId && `${testId}--text`;
            const t19 = enableMotionFG && resizing && !maxWidth ? $44fbebf285dcdbcf$var$styles.textClip : $44fbebf285dcdbcf$var$styles.textEllipsis;
            const t20 = spacing === "spacious" && $44fbebf285dcdbcf$var$styles.textSpacious;
            let t21;
            if ($[59] !== t19 || $[60] !== t20) {
                t21 = (0, $hekY6.default)([
                    $44fbebf285dcdbcf$var$styles.text,
                    t19,
                    t20
                ]);
                $[59] = t19;
                $[60] = t20;
                $[61] = t21;
            } else t21 = $[61];
            let t22;
            if ($[62] !== children || $[63] !== t17 || $[64] !== t18 || $[65] !== t21) {
                t22 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    style: t17,
                    "data-testid": t18,
                    className: t21,
                    children: children
                });
                $[62] = children;
                $[63] = t17;
                $[64] = t18;
                $[65] = t21;
                $[66] = t22;
            } else t22 = $[66];
            let t23;
            if ($[67] !== hasTrailingMetric || $[68] !== metricBadgeAppearance || $[69] !== resolvedColor || $[70] !== testId || $[71] !== trailingMetric) {
                t23 = hasTrailingMetric && !resolvedColor.startsWith("accent-") && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    "data-lozenge-metric-wrapper": true,
                    "data-testid": testId && `${testId}--metric`,
                    className: (0, $hekY6.default)([
                        $44fbebf285dcdbcf$var$styles.metricBadgeWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $78t8C.default), {
                        appearance: metricBadgeAppearance,
                        children: trailingMetric
                    })
                });
                $[67] = hasTrailingMetric;
                $[68] = metricBadgeAppearance;
                $[69] = resolvedColor;
                $[70] = testId;
                $[71] = trailingMetric;
                $[72] = t23;
            } else t23 = $[72];
            let t24;
            if ($[73] !== isInteractive || $[74] !== testId) {
                t24 = isInteractive && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "",
                    size: "small",
                    color: "currentColor",
                    testId: testId && `${testId}--chevron`
                });
                $[73] = isInteractive;
                $[74] = testId;
                $[75] = t24;
            } else t24 = $[75];
            innerContent = /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                "data-testid": testId ? `${testId}--content` : undefined,
                ...enableMotionFG ? resizingWidth : undefined,
                className: t13,
                children: [
                    t14,
                    t22,
                    t23,
                    t24
                ]
            });
            if (isInteractive) {
                let t25;
                if ($[76] !== isLoading) {
                    t25 = isLoading && {
                        "aria-busy": true,
                        "aria-disabled": true,
                        isDisabled: true
                    };
                    $[76] = isLoading;
                    $[77] = t25;
                } else t25 = $[77];
                const t26 = `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? "var(--border-color) !important" : "transparent"}`;
                const t27 = isSelected ? $44fbebf285dcdbcf$var$pressedBackgroundMapping[resolvedColor] : undefined;
                const t28 = isLoading ? "progress" : "pointer";
                let t29;
                if ($[78] !== commonStyleOverrides || $[79] !== t26 || $[80] !== t27 || $[81] !== t28) {
                    t29 = {
                        ...commonStyleOverrides,
                        border: t26,
                        backgroundColor: t27,
                        cursor: t28
                    };
                    $[78] = commonStyleOverrides;
                    $[79] = t26;
                    $[80] = t27;
                    $[81] = t28;
                    $[82] = t29;
                } else t29 = $[82];
                let t30;
                if ($[83] !== isSelected) {
                    t30 = isSelected && {
                        "data-selected": "true"
                    };
                    $[83] = isSelected;
                    $[84] = t30;
                } else t30 = $[84];
                t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kh0hi.default), {
                    ref: ref,
                    xcss: (0, $w6R6I.cx)($44fbebf285dcdbcf$var$styles.container, !isLoading && enableButtonMotionFG ? $44fbebf285dcdbcf$var$interactiveMotionStyles.motion : enableMotionFG && $44fbebf285dcdbcf$var$styles.motionContainer, spacing === "spacious" && $44fbebf285dcdbcf$var$styles.containerSpacious, !isSelected && $44fbebf285dcdbcf$var$styles.iconBorderFilter, $44fbebf285dcdbcf$var$styles[colorStyleKey], !isLoading && $44fbebf285dcdbcf$var$styles[interactiveStyleKey], hasTrailingMetric && $44fbebf285dcdbcf$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === "neutral" && $44fbebf285dcdbcf$var$styles.containerBadgeNeutralAppearance),
                    ...t25,
                    "aria-label": isLoading ? "Loading" : ariaLabel,
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHaspopup,
                    onClick: isLoading ? undefined : onClick,
                    style: t29,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    interactionName: interactionName,
                    componentName: "LozengeDropdownTrigger",
                    ...t30,
                    children: [
                        innerContent,
                        isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "data-testid": testId ? `${testId}--loading-overlay` : undefined,
                            className: (0, $hekY6.default)([
                                $44fbebf285dcdbcf$var$styles.loadingOverlay,
                                enableButtonMotionFG && $44fbebf285dcdbcf$var$styles.loadingOverlayMotion
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                                size: spacing === "spacious" ? "small" : "xsmall",
                                label: ", Loading",
                                testId: testId ? `${testId}--loading-spinner` : undefined
                            })
                        })
                    ]
                });
                break bb1;
            }
        }
        $[20] = analyticsContext;
        $[21] = ariaControls;
        $[22] = ariaExpanded;
        $[23] = ariaHaspopup;
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = colorStyleKey;
        $[27] = commonStyleOverrides;
        $[28] = hasTrailingMetric;
        $[29] = iconBefore;
        $[30] = interactionName;
        $[31] = interactiveStyleKey;
        $[32] = isInteractive;
        $[33] = isLoading;
        $[34] = isSelected;
        $[35] = maxWidth;
        $[36] = maxWidthIsPc;
        $[37] = maxWidthValue;
        $[38] = metricBadgeAppearance;
        $[39] = onClick;
        $[40] = ref;
        $[41] = resizing;
        $[42] = resizingWidth;
        $[43] = resolvedColor;
        $[44] = resolvedTrailingMetricAppearance;
        $[45] = spacing;
        $[46] = style?.color;
        $[47] = testId;
        $[48] = trailingMetric;
        $[49] = innerContent;
        $[50] = t12;
    } else {
        innerContent = $[49];
        t12 = $[50];
    }
    if (t12 !== Symbol.for("react.early_return_sentinel")) return t12;
    const t13 = spacing === "spacious" && $44fbebf285dcdbcf$var$styles.containerSpacious;
    const t14 = spacing !== "spacious" && hasTrailingMetric && $44fbebf285dcdbcf$var$styles.containerBadgePadding;
    const t15 = $44fbebf285dcdbcf$var$styles[colorStyleKey];
    const t16 = hasTrailingMetric && resolvedTrailingMetricAppearance === "neutral" && $44fbebf285dcdbcf$var$styles.containerBadgeNeutralAppearance;
    let t17;
    if ($[85] !== t13 || $[86] !== t14 || $[87] !== t15 || $[88] !== t16) {
        t17 = (0, $hekY6.default)([
            $44fbebf285dcdbcf$var$styles.container,
            t13,
            t14,
            t15,
            $44fbebf285dcdbcf$var$styles.iconBorderFilter,
            t16
        ]);
        $[85] = t13;
        $[86] = t14;
        $[87] = t15;
        $[88] = t16;
        $[89] = t17;
    } else t17 = $[89];
    let t18;
    if ($[90] !== commonStyleOverrides || $[91] !== innerContent || $[92] !== ref || $[93] !== t17 || $[94] !== testId) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: ref,
            style: commonStyleOverrides,
            "data-testid": testId,
            className: t17,
            children: innerContent
        });
        $[90] = commonStyleOverrides;
        $[91] = innerContent;
        $[92] = ref;
        $[93] = t17;
        $[94] = testId;
        $[95] = t18;
    } else t18 = $[95];
    return t18;
} : ({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $cozmU.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $4Uejl.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $cozmU.useRef)(true);
    const isInteractive = typeof onClick === 'function'; // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $gnQSb.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $iNqPL.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $gnQSb.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor; // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $cozmU.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $iDrrr.fg)('platform-dst-motion-uplift');
    const enableButtonMotionFG = (0, $iDrrr.fg)('platform-dst-motion-uplift-button');
    const innerContent = /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        "data-testid": testId ? `${testId}--content` : undefined,
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $hekY6.default)([
            $44fbebf285dcdbcf$var$styles.content,
            spacing === 'spacious' && $44fbebf285dcdbcf$var$styles.contentSpacious,
            isInteractive && enableButtonMotionFG && $44fbebf285dcdbcf$var$styles.loadingMotion,
            isLoading && $44fbebf285dcdbcf$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $44fbebf285dcdbcf$var$styles.maxWidth
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gSFZN.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    // The text fills 100% of the inner content wrapper. The container's
                    // own max-width (set on the container via commonStyleOverrides) handles
                    // the actual size constraint, so the text just needs to fill the available
                    // space and truncate when it overflows.
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style?.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $hekY6.default)([
                    $44fbebf285dcdbcf$var$styles.text,
                    enableMotionFG && resizing && !maxWidth ? $44fbebf285dcdbcf$var$styles.textClip : $44fbebf285dcdbcf$var$styles.textEllipsis,
                    spacing === 'spacious' && $44fbebf285dcdbcf$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $hekY6.default)([
                    $44fbebf285dcdbcf$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $78t8C.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kh0hi.default), {
        ref: ref,
        xcss: (0, $w6R6I.cx)($44fbebf285dcdbcf$var$styles.container, !isLoading && enableButtonMotionFG ? $44fbebf285dcdbcf$var$interactiveMotionStyles.motion : enableMotionFG && $44fbebf285dcdbcf$var$styles.motionContainer, spacing === 'spacious' && $44fbebf285dcdbcf$var$styles.containerSpacious, !isSelected && $44fbebf285dcdbcf$var$styles.iconBorderFilter, $44fbebf285dcdbcf$var$styles[colorStyleKey], !isLoading && $44fbebf285dcdbcf$var$styles[interactiveStyleKey], hasTrailingMetric && $44fbebf285dcdbcf$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $44fbebf285dcdbcf$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $44fbebf285dcdbcf$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        },
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-testid": testId ? `${testId}--loading-overlay` : undefined,
                className: (0, $hekY6.default)([
                    $44fbebf285dcdbcf$var$styles.loadingOverlay,
                    enableButtonMotionFG && $44fbebf285dcdbcf$var$styles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $44fbebf285dcdbcf$var$styles.container,
            spacing === 'spacious' && $44fbebf285dcdbcf$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $44fbebf285dcdbcf$var$styles.containerBadgePadding,
            $44fbebf285dcdbcf$var$styles[colorStyleKey],
            $44fbebf285dcdbcf$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $44fbebf285dcdbcf$var$styles.containerBadgeNeutralAppearance
        ]),
        children: innerContent
    });
}));
var $44fbebf285dcdbcf$export$2e2bcd8739ae039 = $44fbebf285dcdbcf$var$LozengeBase;
module.exports["default"] = $44fbebf285dcdbcf$export$2e2bcd8739ae039;

});

parcelRegister("jE4FX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $7ff854ca64b7ec82$export$ce4b6a469c26f53f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LinkWrapper(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers } = t0;
    if (isLink && href) {
        const t1 = testId ? `${testId}--link` : undefined;
        const t2 = linkHandlers?.onMouseEnter;
        const t3 = linkHandlers?.onMouseLeave;
        const t4 = linkHandlers?.onMouseDown;
        const t5 = linkHandlers?.onFocus;
        const t6 = linkHandlers?.onBlur;
        let t7;
        if ($[0] !== LinkComponent || $[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)(LinkComponent, {
                href: href,
                testId: t1,
                onClick: onClick,
                onMouseEnter: t2,
                onMouseLeave: t3,
                onMouseDown: t4,
                onFocus: t5,
                onBlur: t6,
                children: children
            });
            $[0] = LinkComponent;
            $[1] = children;
            $[2] = href;
            $[3] = onClick;
            $[4] = t1;
            $[5] = t2;
            $[6] = t3;
            $[7] = t4;
            $[8] = t5;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    let t1;
    if ($[11] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
            children: children
        });
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : function LinkWrapper({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $8aG6j.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers?.onMouseEnter,
        onMouseLeave: linkHandlers?.onMouseLeave,
        onMouseDown: linkHandlers?.onMouseDown,
        onFocus: linkHandlers?.onFocus,
        onBlur: linkHandlers?.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
        children: children
    });
};
module.exports["LinkWrapper"] = $7ff854ca64b7ec82$export$ce4b6a469c26f53f;

});

parcelRegister("kMm3u", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $aIOjp = parcelRequire("aIOjp");


var $jYHUK = parcelRequire("jYHUK");

const $7dae55059bc612c1$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $7dae55059bc612c1$var$motionWrapperStyles = null; // Props for the removable wrapper
const $7dae55059bc612c1$export$898a500849bb5cf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RemovableWrapper(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children } = t0;
    if (isRemovable) {
        let t1;
        if ($[0] !== children || $[1] !== onShrinkOutExitComplete || $[2] !== status) {
            t1 = !(status === (0, $jYHUK.TagStatus).Removed) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aIOjp.default), {
                onFinish: onShrinkOutExitComplete ? (phase)=>{
                    if (phase === "exiting") onShrinkOutExitComplete();
                } : undefined,
                children: (motion)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        ref: motion.ref,
                        className: (0, $hekY6.default)([
                            "_3iDTPbccYA"
                        ]),
                        children: children
                    })
            }, $7dae55059bc612c1$var$removableShrinkOutChildKey);
            $[0] = children;
            $[1] = onShrinkOutExitComplete;
            $[2] = status;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] !== t1) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
                children: t1
            });
            $[4] = t1;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    return children;
} : function RemovableWrapper({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
        children: !(status === (0, $jYHUK.TagStatus).Removed) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aIOjp.default), {
            onFinish: onShrinkOutExitComplete ? (phase)=>{
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: (motion)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    ref: motion.ref,
                    className: (0, $hekY6.default)([
                        "_3iDTPbccYA"
                    ]),
                    children: children
                })
        }, $7dae55059bc612c1$var$removableShrinkOutChildKey)
    });
    return children;
};
module.exports["RemovableWrapper"] = $7dae55059bc612c1$export$898a500849bb5cf4;

});

parcelRegister("fc5bD", function(module, exports) {
/* tag-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Measures settled truncation in onStart while useMotion drives each width animation phase.

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $iODl6 = parcelRequire("iODl6");


var $kUXcd = parcelRequire("kUXcd");


var $64L5u = parcelRequire("64L5u");


var $jYHUK = parcelRequire("jYHUK");

const $f865353e1e358877$var$tagMotionKey = 'atlaskit-tag-motion';
const $f865353e1e358877$var$motionWrapperStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbkfkE _2iEGP28wUV",
    entering: "_2fBhteQvDB",
    exiting: "_2fBhteZkFk",
    reducedMotion: "_39Ohv4YbGa"
};
const $f865353e1e358877$var$motionContentStyles = {
    root: "_4c065U1Y8M _2Y7lL41Y8M _3iDTPbQ4SZ _4ouGXIdnbC"
};
function $f865353e1e358877$var$TagMotionContent({ children: children, forwardedRef: forwardedRef, hasMargin: hasMargin, onExitComplete: onExitComplete }) {
    const [motionPhase, setMotionPhase] = (0, $cozmU.useState)(null);
    const [hasEllipsis, setHasEllipsis] = (0, $cozmU.useState)(null);
    const motionElementRef = (0, $cozmU.useRef)(null);
    const { ref: motionRef, state: state } = (0, $64L5u.useMotion)({
        onStart: (phase)=>{
            if (motionElementRef.current) {
                const motionElement = motionElementRef.current;
                const inlineAnimation = motionElement.style.animation;
                motionElement.style.animation = 'none';
                const textElement = motionElement.querySelector('[data-tag-text]');
                setHasEllipsis(Boolean(textElement && textElement.scrollWidth > textElement.clientWidth));
                motionElement.style.animation = inlineAnimation;
            }
            setMotionPhase(phase);
        },
        onFinish: (phase_0)=>{
            if (phase_0 === 'exiting') onExitComplete?.();
        }
    });
    const mergedMotionRef = (0, $cozmU.useMemo)(()=>(0, $lmzCg.default)([
            motionElementRef,
            motionRef
        ]), [
        motionRef
    ]);
    const onAnimationEnd = (0, $cozmU.useCallback)((event)=>{
        if (event.target === event.currentTarget) setMotionPhase(null);
    }, []);
    const activeMotionPhase = state === 'entering' || state === 'exiting' ? state : motionPhase;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: mergedMotionRef,
        onAnimationEnd: onAnimationEnd,
        className: (0, $hekY6.default)([
            $f865353e1e358877$var$motionWrapperStyles.root,
            activeMotionPhase === 'entering' && $f865353e1e358877$var$motionWrapperStyles.entering,
            activeMotionPhase === 'exiting' && $f865353e1e358877$var$motionWrapperStyles.exiting,
            $f865353e1e358877$var$motionWrapperStyles.reducedMotion
        ]),
        children: hasMargin ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $f865353e1e358877$var$motionContentStyles.root
            ]),
            children: children({
                hasEllipsis: hasEllipsis,
                isEntering: activeMotionPhase === 'entering',
                isExiting: activeMotionPhase === 'exiting',
                ref: forwardedRef
            })
        }) : children({
            hasEllipsis: hasEllipsis,
            isEntering: activeMotionPhase === 'entering',
            isExiting: activeMotionPhase === 'exiting',
            ref: forwardedRef
        })
    });
}
function $f865353e1e358877$export$6adae1772ccf137c({ children: children, forwardedRef: forwardedRef, hasMargin: hasMargin, onExitComplete: onExitComplete, status: status }) {
    const outerPresence = (0, $kUXcd.useExitingPersistence)();
    const isRemoved = status === (0, $jYHUK.TagStatus).Removed || outerPresence.isExiting;
    const shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    const latestExitState = (0, $cozmU.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    const onMotionExitComplete = (0, $cozmU.useCallback)(()=>{
        const latest = latestExitState.current;
        if (latest.outerPresence.isExiting) latest.outerPresence.onFinish?.();
        if (latest.status === (0, $jYHUK.TagStatus).Removed) latest.onExitComplete?.();
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
        appear: shouldAppear,
        children: !isRemoved && /*#__PURE__*/ (0, $8aG6j.jsx)($f865353e1e358877$var$TagMotionContent, {
            forwardedRef: forwardedRef,
            hasMargin: hasMargin,
            onExitComplete: onMotionExitComplete,
            children: children
        }, $f865353e1e358877$var$tagMotionKey)
    });
}
module.exports["TagMotion"] = $f865353e1e358877$export$6adae1772ccf137c;

});

parcelRegister("8dYJC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d35fbf328b281ebf$export$84acd183858d8235 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useButtonInteraction() {
    const $ = (0, $bDgLe.c)(7);
    const [isLinkHovered, setIsLinkHovered] = (0, $cozmU.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $cozmU.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $cozmU.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $cozmU.useState)(false);
    const hadMouseDownRef = (0, $cozmU.useRef)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                e?.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        };
        $[0] = t0;
    } else t0 = $[0];
    const buttonHandlers = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        };
        $[1] = t1;
    } else t1 = $[1];
    const linkHandlers = t1;
    let t2;
    if ($[2] !== isButtonFocused || $[3] !== isLinkFocused || $[4] !== isLinkHovered || $[5] !== isOverButton) {
        t2 = {
            isLinkHovered: isLinkHovered,
            isOverButton: isOverButton,
            isButtonFocused: isButtonFocused,
            isLinkFocused: isLinkFocused,
            buttonHandlers: buttonHandlers,
            linkHandlers: linkHandlers
        };
        $[2] = isButtonFocused;
        $[3] = isLinkFocused;
        $[4] = isLinkHovered;
        $[5] = isOverButton;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function useButtonInteraction() {
    const [isLinkHovered, setIsLinkHovered] = (0, $cozmU.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $cozmU.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $cozmU.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $cozmU.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $cozmU.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $cozmU.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e?.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $cozmU.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
};
module.exports["useButtonInteraction"] = $d35fbf328b281ebf$export$84acd183858d8235;

});

parcelRegister("4ea0k", function(module, exports) {

var $i1t43 = parcelRequire("i1t43");

function $40ded2f591fcc24d$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $i1t43.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
module.exports["useLink"] = $40ded2f591fcc24d$export$dcf14c9974fe2767;

});

parcelRegister("7tNhr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9hXom = parcelRequire("9hXom");

const $e0b90610328cbf13$export$97d8be09cd53869b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRemoveButton(t0) {
    const $ = (0, $bDgLe.c)(17);
    const { isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: t1, buttonHandlers: buttonHandlers } = t0;
    const shape = t1 === undefined ? "default" : t1;
    let t2;
    if ($[0] !== buttonHandlers || $[1] !== removingTag) {
        t2 = ()=>{
            removingTag();
            buttonHandlers?.onFocus();
        };
        $[0] = buttonHandlers;
        $[1] = removingTag;
        $[2] = t2;
    } else t2 = $[2];
    const handleFocus = t2;
    let t3;
    if ($[3] !== buttonHandlers || $[4] !== showingTag) {
        t3 = ()=>{
            showingTag();
            buttonHandlers?.onBlur();
        };
        $[3] = buttonHandlers;
        $[4] = showingTag;
        $[5] = t3;
    } else t3 = $[5];
    const handleBlur = t3;
    let t4;
    bb0: {
        if (!isRemovable) {
            t4 = undefined;
            break bb0;
        }
        const t5 = `${removeButtonLabel || "Remove"} ${tagText}`;
        const t6 = buttonHandlers?.onMouseEnter;
        const t7 = buttonHandlers?.onMouseLeave;
        const t8 = buttonHandlers?.onMouseDown;
        const t9 = testId ? `close-button-${testId}` : undefined;
        let t10;
        if ($[6] !== handleBlur || $[7] !== handleFocus || $[8] !== handleRemoveRequest || $[9] !== onKeyPress || $[10] !== shape || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
            t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9hXom.default), {
                "aria-label": t5,
                onClick: handleRemoveRequest,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyPress: onKeyPress,
                onMouseEnter: t6,
                onMouseLeave: t7,
                onMouseDown: t8,
                testId: t9,
                shape: shape
            });
            $[6] = handleBlur;
            $[7] = handleFocus;
            $[8] = handleRemoveRequest;
            $[9] = onKeyPress;
            $[10] = shape;
            $[11] = t5;
            $[12] = t6;
            $[13] = t7;
            $[14] = t8;
            $[15] = t9;
            $[16] = t10;
        } else t10 = $[16];
        t4 = t10;
    }
    return t4;
} : function useRemoveButton({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        removingTag();
        buttonHandlers?.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $cozmU.useCallback)(()=>{
        showingTag();
        buttonHandlers?.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9hXom.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers?.onMouseEnter,
            onMouseLeave: buttonHandlers?.onMouseLeave,
            onMouseDown: buttonHandlers?.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
};
module.exports["useRemoveButton"] = $e0b90610328cbf13$export$97d8be09cd53869b;

});

parcelRegister("hPeTN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cZrKk = parcelRequire("cZrKk");


var $jYHUK = parcelRequire("jYHUK");

const $e4d4298840c9a264$export$f26019543e9f862f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useTagRemoval(onBeforeRemoveAction) {
    const $ = (0, $bDgLe.c)(10);
    const [status, setStatus] = (0, $cozmU.useState)((0, $jYHUK.TagStatus).Showing);
    let t0;
    if ($[0] !== onBeforeRemoveAction) {
        t0 = ()=>{
            const beforeAction = onBeforeRemoveAction ?? (0, $cZrKk.defaultBeforeRemoveAction);
            if (beforeAction()) setStatus((0, $jYHUK.TagStatus).Removed);
        };
        $[0] = onBeforeRemoveAction;
        $[1] = t0;
    } else t0 = $[1];
    const handleRemoveRequest = t0;
    let t1;
    if ($[2] !== handleRemoveRequest) {
        t1 = (e)=>{
            const spacebarOrEnter = e.key === " " || e.key === "Enter";
            if (spacebarOrEnter) {
                e.stopPropagation();
                handleRemoveRequest();
            }
        };
        $[2] = handleRemoveRequest;
        $[3] = t1;
    } else t1 = $[3];
    const onKeyPress = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setStatus((0, $jYHUK.TagStatus).Removing);
        $[4] = t2;
    } else t2 = $[4];
    const removingTag = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setStatus((0, $jYHUK.TagStatus).Showing);
        $[5] = t3;
    } else t3 = $[5];
    const showingTag = t3;
    let t4;
    if ($[6] !== handleRemoveRequest || $[7] !== onKeyPress || $[8] !== status) {
        t4 = {
            status: status,
            handleRemoveRequest: handleRemoveRequest,
            onKeyPress: onKeyPress,
            removingTag: removingTag,
            showingTag: showingTag
        };
        $[6] = handleRemoveRequest;
        $[7] = onKeyPress;
        $[8] = status;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : function useTagRemoval(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $cozmU.useState)((0, $jYHUK.TagStatus).Showing);
    const handleRemoveRequest = (0, $cozmU.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $cZrKk.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $jYHUK.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $cozmU.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $cozmU.useCallback)(()=>setStatus((0, $jYHUK.TagStatus).Removing), []);
    const showingTag = (0, $cozmU.useCallback)(()=>setStatus((0, $jYHUK.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
};
module.exports["useTagRemoval"] = $e4d4298840c9a264$export$f26019543e9f862f;

});

parcelRegister("1knih", function(module, exports) {
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $118469406feb527f$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;
module.exports["getTagText"] = $118469406feb527f$export$7d100de1166870f6;

});

parcelRegister("7dnxH", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $734dd2209be61cf4$var$tagSwatchBeforeStyles = {
    swatch: "_0bjKvDcjp5 _39xV02eUER _0jFU0VeUER _3YEZNOdnbC"
};
const $734dd2209be61cf4$var$tagSwatchBeforeColorStyles = {
    gray: "_0KLXrueZ10",
    blue: "_0KLXru28sy",
    green: "_0KLXru50ZN",
    red: "_0KLXru0cUQ",
    yellow: "_0KLXruC29w",
    purple: "_0KLXruf89Q",
    lime: "_0KLXruZcd0",
    magenta: "_0KLXrupmfs",
    orange: "_0KLXruuwVU",
    teal: "_0KLXrufjGw"
};
const $734dd2209be61cf4$var$SwatchBefore = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SwatchBefore(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { colorKey: colorKey, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole } = t0;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) {
        let t1;
        if ($[0] !== swatchBeforeLabel || $[1] !== swatchBeforeRole) {
            t1 = swatchBeforeLabel && swatchBeforeRole ? {
                "aria-label": swatchBeforeLabel,
                role: swatchBeforeRole
            } : {};
            $[0] = swatchBeforeLabel;
            $[1] = swatchBeforeRole;
            $[2] = t1;
        } else t1 = $[2];
        const t2 = $734dd2209be61cf4$var$tagSwatchBeforeColorStyles[colorKey];
        let t3;
        if ($[3] !== t2) {
            t3 = (0, $hekY6.default)([
                $734dd2209be61cf4$var$tagSwatchBeforeStyles.swatch,
                t2
            ]);
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== t1 || $[6] !== t3) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ...t1,
                className: t3
            });
            $[5] = t1;
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    let t1;
    if ($[8] !== swatchBeforeLabel || $[9] !== swatchBeforeRole) {
        t1 = swatchBeforeLabel && swatchBeforeRole ? {
            "aria-label": swatchBeforeLabel,
            role: swatchBeforeRole
        } : {};
        $[8] = swatchBeforeLabel;
        $[9] = swatchBeforeRole;
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== swatchBefore) {
        t2 = {
            backgroundColor: swatchBefore
        };
        $[11] = swatchBefore;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $734dd2209be61cf4$var$tagSwatchBeforeStyles.swatch
        ]);
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...t1,
            style: t2,
            className: t3
        });
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : function SwatchBefore({ colorKey: colorKey, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...swatchBeforeLabel && swatchBeforeRole ? {
            'aria-label': swatchBeforeLabel,
            role: swatchBeforeRole
        } : {},
        className: (0, $hekY6.default)([
            $734dd2209be61cf4$var$tagSwatchBeforeStyles.swatch,
            $734dd2209be61cf4$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...swatchBeforeLabel && swatchBeforeRole ? {
            'aria-label': swatchBeforeLabel,
            role: swatchBeforeRole
        } : {},
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $hekY6.default)([
            $734dd2209be61cf4$var$tagSwatchBeforeStyles.swatch
        ])
    });
};
var $734dd2209be61cf4$export$2e2bcd8739ae039 = $734dd2209be61cf4$var$SwatchBefore;
module.exports["default"] = $734dd2209be61cf4$export$2e2bcd8739ae039;

});

parcelRegister("iNqPL", function(module, exports) {
const $aa245a5a104d3c22$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};
module.exports["getThemeStyles"] = $aa245a5a104d3c22$export$a3fc04b8551e006a;

});

parcelRegister("gSFZN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $32a88ade818f9c6d$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $32a88ade818f9c6d$var$styles = {
    motion: "_1kOSYtWkA1 _3Z9K0wLrT7 _0qk6IKxt7V"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
const $32a88ade818f9c6d$var$IconRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { icon: Icon, color: color, testId: testId, size: size } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = $32a88ade818f9c6d$var$getIconColor(color);
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    const iconColor = t1;
    let t2;
    if ($[2] !== Icon || $[3] !== iconColor || $[4] !== size || $[5] !== testId) {
        t2 = (0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $32a88ade818f9c6d$var$styles.motion,
            style: {
                color: iconColor
            },
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                label: "",
                size: size,
                testId: testId
            })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            color: iconColor,
            label: "",
            size: size,
            testId: testId
        });
        $[2] = Icon;
        $[3] = iconColor;
        $[4] = size;
        $[5] = testId;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $32a88ade818f9c6d$var$getIconColor(color);
    return (0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $32a88ade818f9c6d$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$32a88ade818f9c6d$export$2e2bcd8739ae039 = $32a88ade818f9c6d$var$IconRenderer;
module.exports["default"] = $32a88ade818f9c6d$export$2e2bcd8739ae039;

});

parcelRegister("gnQSb", function(module, exports) {
// Map legacy appearance to new color values
const $9a983afa26500c92$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $9a983afa26500c92$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $9a983afa26500c92$var$legacyAppearanceMap[appearance] ?? appearance;
};
module.exports["resolveLozengeColor"] = $9a983afa26500c92$export$acf5d2b7dc999bda;

});

parcelRegister("jYHUK", function(module, exports) {
// Tag status enum
var $37498e9392fb57df$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
module.exports["TagStatus"] = $37498e9392fb57df$export$74452314b63acabc;

});

parcelRegister("9hXom", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");

const $345a0827c4245121$var$removeButtonStyles = {
    root: "_30huDKYbGa _0bjKvDcjp5 _2YLqiKPgdg _3SamIHPgdg _2Y7lL4Pgdg _4c065UPgdg _3iDTPbQ4SZ _0jFU0VQAma _39xV02QAma _1OKFqYPgdg _0hPCNLDIqT _37wbyuDIqT _4xdlr0DIqT _034jHtYbGa _0KLXru66of _1UtDYzy7kJ _0wOv4Q7zJH _1pp6NdIZbP _0GTcwRLl21 _2xTnZxLl21 _34b3D2dnbC _1eOmH6o126 _3gzVzLN4oS",
    circle: "_0bjKvDS5Zs _34b3D2dnbC",
    focusRing: "_34b3D2FQfX",
    newIcon: "_1OKFqYFQfX"
};
const $345a0827c4245121$var$RemoveButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { "aria-label": ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: t1 } = t0;
    const shape = t1 === undefined ? "default" : t1;
    const t2 = shape === "circle" && $345a0827c4245121$var$removeButtonStyles.circle;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($345a0827c4245121$var$removeButtonStyles.root, t2, $345a0827c4245121$var$removeButtonStyles.newIcon, (0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") && $345a0827c4245121$var$removeButtonStyles.focusRing);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            color: "currentColor",
            label: "",
            size: "small"
        });
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== ariaLabel || $[4] !== onBlur || $[5] !== onClick || $[6] !== onFocus || $[7] !== onKeyPress || $[8] !== onMouseDown || $[9] !== onMouseEnter || $[10] !== onMouseLeave || $[11] !== onMouseOut || $[12] !== onMouseOver || $[13] !== onMouseUp || $[14] !== t3 || $[15] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            xcss: t3,
            "aria-label": ariaLabel,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyPress: onKeyPress,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            testId: testId,
            children: t4
        });
        $[3] = ariaLabel;
        $[4] = onBlur;
        $[5] = onClick;
        $[6] = onFocus;
        $[7] = onKeyPress;
        $[8] = onMouseDown;
        $[9] = onMouseEnter;
        $[10] = onMouseLeave;
        $[11] = onMouseOut;
        $[12] = onMouseOver;
        $[13] = onMouseUp;
        $[14] = t3;
        $[15] = testId;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($345a0827c4245121$var$removeButtonStyles.root, shape === 'circle' && $345a0827c4245121$var$removeButtonStyles.circle, $345a0827c4245121$var$removeButtonStyles.newIcon, (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $345a0827c4245121$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $345a0827c4245121$export$2e2bcd8739ae039 = $345a0827c4245121$var$RemoveButton;
module.exports["default"] = $345a0827c4245121$export$2e2bcd8739ae039;

});

parcelRegister("cZrKk", function(module, exports) {
const $704d3b5ea6c7a68f$export$279e7025ed114474 = ()=>true;
module.exports["defaultBeforeRemoveAction"] = $704d3b5ea6c7a68f$export$279e7025ed114474;

});


$parcel$global.rlb("Wowvf")
//# sourceMappingURL=vendors~editor_atlaskit_sm.734de39c.js.map
